<template>
  <div>

 <!-- start company info header -->

  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>

  <!-- end company info header -->

 <div style="text-align:center;">
   <h4 class="title">Task Builder</h4>
      <p class="category">
      What do you want to do today?
      </p>
 </div>



  <div class="row" v-if="displayPreview">
   <h5  style="font-weight:bold;" v-if="displaySavedHeader">
        Saved Changes
    </h5>
  	 <div style="width:100%;padding-bottom:30px;">


    <div v-for="(cri, index) in new_reso_items_saved">
     <card>
    	<span style="font-weight:bold;">Custom Resolution Item: </span> {{cri.text}}

    	 <span style="color:red;cursor:pointer;" @click="removeSavedNewResoItem(cri.id, index)" > [Delete]</span>
     </card>
    </div>

    <div v-for="(cic, index) in coyInfoChangeSaved">
	<card>
			<div v-if="cic.ch_type=='ch_address'">
				<span style='font-weight:bold;'>New company address:</span> {{cic.address}}

				 <span v-if="cic.status==1" style="color:red;cursor:pointer;" @click="removeSavedCoyInfoChange(cic.id, index)" > [Delete]</span>
			</div>


			<div v-if="cic.ch_type=='ch_coy_name'">
				<span style='font-weight:bold;'>New company name:</span> {{cic.coy_name}}

				 <span v-if="cic.status==1" style="color:red;cursor:pointer;" @click="removeSavedCoyInfoChange(cic.id, index)" > [Delete]</span>
			</div>
	
			<div v-if="cic.ch_type=='ch_coy_fye'">
				<span style='font-weight:bold;'>New Financial Year-end Date:</span> {{cic.coy_fye}}

				 <span v-if="cic.status==1" style="color:red;cursor:pointer;" @click="removeSavedCoyInfoChange(cic.id, index)" > [Delete]</span>
			</div>
	
				<div v-if="cic.ch_type=='ch_coy_activity'">
					<span v-if="cic.coy_pa1_code">
						<span style='font-weight:bold;'>New Principal Activity I:</span> {{cic.coy_pa1_code}} - {{cic.coy_pa1_title}} ({{cic.coy_pa1_desc}})
						<br/>
					</span>
					<span v-if="cic.coy_pa2_code">
						<span style='font-weight:bold;'>New Principal Activity II:</span> {{cic.coy_pa2_code}} - {{cic.coy_pa2_title}} ({{cic.coy_pa2_desc}})
					</span>
					
				 <span v-if="cic.status==1" style="color:red;cursor:pointer;" @click="removeSavedCoyInfoChange(cic.id, index)" > [Delete]</span>
			</div>
	
	
	

			<div v-if="cic.ch_type=='ch_strike_off'">
				<span style='font-weight:bold;'>Strike-off Company</span>

				 <span style="color:red;cursor:pointer;" @click="removeSavedCoyInfoChange(cic.id, index)" > [Delete]</span>
			</div>

	</card>
	</div>



  	 	<div v-if="displayPreviewSh2 || displayPreviewSh1" style="font-weight:bold;text-decoration:underline;">
  	 		Changes: Shares
  	 	</div>
     

  	 	<div v-for="(sh, index) in shareholder_changes_saved">
  	 	 <card>
  	 	    <div v-if="sh.transaction_type==1 || sh.transaction_type==1">
				{{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}}):
				<span v-if="sh.transaction_type==1">Increase</span>
				<span v-if="sh.transaction_type==2">Decrease</span>

				  {{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

				  <span v-if="sh.share_type==1">Ordinary</span>
				  <span v-if="sh.share_type==2">Preference</span>
				  <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>

				  Shares
				  	 <span v-if="sh.effective_date">
				  , effective on {{sh.effective_date}}.
				 </span> 
				  <span v-if="sh.status==1" style="color:red;cursor:pointer;"  @click="removeSavedSh(sh.stid, index)"> [Delete]</span>
  	 		</div>
  	 	    <div v-if="sh.transaction_type==3">
  	 	    	Transferring

				{{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

				 <span v-if="sh.share_type==1">Ordinary</span>
				 <span v-if="sh.share_type==2">Preference</span>
				  <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>


				Shares to {{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}})
				<span v-if="sh.effective_date">
				, effective on {{sh.effective_date}}.
				</span>
				<span v-if="sh.status==1" style="color:red;cursor:pointer;"  @click="removeSavedSh(sh.stid, index)"> [Delete]</span>

  	 		</div>
  	 		</card>
  	 	</div>
  	 	
  	 	


  	 	<div v-for="(sh, index) in shareholder_company_changes_saved">
  	 	<card>
  	 	    <div v-if="sh.transaction_type==1 || sh.transaction_type==1">
				{{sh.company_info.company_name}}  ({{sh.company_info.company_reg_num}}):
				<span v-if="sh.transaction_type==1">Increase</span>
				<span v-if="sh.transaction_type==2">Decrease</span>

				  {{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

				  <span v-if="sh.share_type==1">Ordinary</span>
				  <span v-if="sh.share_type==2">Preference</span>
				   <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>

				  Shares
				  	 <span v-if="sh.effective_date">
				  , effective on {{sh.effective_date}}
				  </span>.
				  <span  v-if="sh.status==1" style="color:red;cursor:pointer;"  @click="removeSavedShCoy(sh.stid, index)"> [Delete]</span>
  	 		</div>
  	 	    <div v-if="sh.transaction_type==3">
  	 	    	Transferring

				{{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

				 <span v-if="sh.share_type==1">Ordinary</span>
				 <span v-if="sh.share_type==2">Preference</span>
				  <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>


				<span v-if="sh.shareholder.is_company==1">
					{{sh.shareholder.shareholder_company.company_name}}
				</span>
				<span v-else>
					{{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}})
				</span>
				
				<span v-if="sh.effective_date">
				, effective on {{sh.effective_date}}
				</span>.
				<span v-if="sh.status==1" style="color:red;cursor:pointer;"  @click="removeSavedShCoy(sh.stid, index)"> [Delete]</span>

  	 		</div>
  	 	  </card>	
  	 	</div>



  	 	
  	 	<div v-if="displayPreviewOfficer2 || displayPreviewOfficer1" style="font-weight:bold;text-decoration:underline;">
  	 		Changes: Officers
  	 	</div>
  	 	<div v-for="(oc, index) in officer_changes_saved">
  	 	<card>
  	 		{{oc.person.first_name}} {{oc.person.last_name}} ({{oc.person.gov_id}}):
  	 		<span v-if="oc.status==1">Appointed</span>
  	 		<span v-if="oc.status==2">Resigned</span>
  	 		 As
  	 		 <span v-if="oc.position==1" >Director</span>
  	 		 <span v-if="oc.position==2" >Nominee Director</span>
			 <span v-if="oc.position==3" >Secretary</span>
			 <span v-if="oc.position==4" >Director & Secretary</span>
			 <span v-if="oc.position==5" >Data Protection Officer</span>
			 <span v-if="oc.position==6" >Director & Data Protection Officer</span>

  	 		<span > ({{oc.title}})</span>
			<span v-if="oc.effective_date">
  	 		, effective on {{oc.effective_date}}
  	 		</span>.
  	 	<span v-if="oc.change_status==1" style="color:red;cursor:pointer;"  @click="removeSavedOc(oc.ocid, index)"> [Delete]</span>
  	 	</card>
  	 	</div>
  	 	
  	 	
  	 	<div v-for="(mc, index) in member_changes_saved">
  	 	<card>
  	 		{{mc.person.first_name}} {{mc.person.last_name}} ({{mc.person.gov_id}}):
  	 		<span v-if="mc.status==1">Appointed</span>
  	 		<span v-if="mc.status==2">Resigned</span>
  	     	 as member 
			<span v-if="mc.effective_date">
  	 		, effective on {{mc.effective_date}}
  	 		</span>.
  	 	<span v-if="mc.change_status==1" style="color:red;cursor:pointer;"  @click="removeSavedMc(mc.mcid, index)"> [Delete]</span>
  	 	</card>
  	 	</div>
  	 	
  	 	
  	 	
  	 	<div v-for="(mc, index) in member_company_changes_saved">
  	 	<card>
  	 		{{mc.member.shareholder_company.company_name}}  :
  	 		<span v-if="mc.status==1">Appointed</span>
  	 		<span v-if="mc.status==2">Resigned</span>
  	     	 as member 
			<span v-if="mc.effective_date">
  	 		, effective on {{mc.effective_date}}
  	 		</span>.
  	 	<span v-if="mc.change_status==1" style="color:red;cursor:pointer;"  @click="removeSavedMemberCompany(mc.mcid, index)"> [Delete]</span>
  	 	</card>
  	 	</div>



  	 	<div v-if="displayPreviewShareCert" >
  	 	<card>
  	 		<span style="font-weight:bold;text-decoration:underline;">New Share Certificate</span>
  	 		<br/>

  	 		<span v-if="share_cert_saved.shareholder.person">
  	 		{{share_cert_saved.shareholder.person.first_name}}  {{share_cert_saved.shareholder.person.last_name}} ( {{share_cert_saved.shareholder.person.gov_id}})
  	 		</span>

  	 		<span v-if="share_cert_saved.shareholder.shareholder_company">
  	 		{{share_cert_saved.shareholder.shareholder_company.company_name}}  ( {{share_cert_saved.shareholder.shareholder_company.company_reg_num}})
  	 		</span>

  	 		:: {{share_cert_saved.num_shares}} {{share_cert_saved.share_type_str}} Shares
		</card>
  	 	</div>

  	 <!--start: saved: cancel share certs-->
	<div v-for="(sc, index) in cancel_share_certs_saved">
	<card>
		<span style="font-weight:bold">Cancel Share Certificate #{{sc.share_cert.cert_number}} </span>

		<span v-if="sc.share_cert.shareholder.person">
		{{sc.share_cert.shareholder.person.first_name}}  {{sc.share_cert.shareholder.person.last_name}} ( {{sc.share_cert.shareholder.person.gov_id}})
		</span>
		<span v-if="sc.share_cert.shareholder.shareholder_company">
			{{sc.share_cert.shareholder.shareholder_company.company_name}}  ( {{sc.share_cert.shareholder.shareholder_company.company_reg_num}})
		</span>

						:: {{sc.share_cert.num_shares}} {{sc.share_cert.share_type_str}} Shares  
							 <span v-if="sc.effective_date"> (Eff. {{sc.effective_date}}) </span>
		<span v-if="sc.status==1" style="color:red;cursor:pointer;" @click="removeSavedCancelShareCert(sc.id,index)" > [Delete]</span>
	</card>	
	</div>
	<!--end: saved: cancel share certs-->


  	<!--start: saved: issue share certs-->
	<div v-for="(sc, index) in issue_share_certs_saved">
	<card>
		<span style="font-weight:bold">Issue Share Certificate #{{sc.share_cert.cert_number}} </span>
		<span v-if="sc.share_cert.shareholder.person">
		{{sc.share_cert.shareholder.person.first_name}}  {{sc.share_cert.shareholder.person.last_name}} ( {{sc.share_cert.shareholder.person.gov_id}})
		</span>
		<span v-if="sc.share_cert.shareholder.shareholder_company">
			{{sc.share_cert.shareholder.shareholder_company.company_name}}  ( {{sc.share_cert.shareholder.shareholder_company.company_reg_num}})
		</span>


						:: {{sc.share_cert.num_shares}} {{sc.share_cert.share_type_str}} Shares  
							 <span v-if="sc.effective_date">(Eff. {{sc.effective_date}}) </span>
		<span v-if="sc.status==1"  style="color:red;cursor:pointer;" @click="removeSavedIssueShareCert(sc.id,index)" > [Delete]</span>
	</card>
	</div>
	<!--end: saved: issue share certs-->



  	 </div> <!-- end saved changes: preivew -->


  </div>

   <div style="margin-top:50px;">
 </div>



      <!-- start resolution fields  -->
   <card>
   
    <div class="row" style="margin-bottom:17px;">
      <label class="col-sm-2 col-form-label">Task ID</label>
      <div class="col-sm-7" style="font-weight:bold;">
      	 <span  v-if="taskid!=0">{{taskid}} </span>
      	  <span v-else style="color:green;">New Task</span>
            
            
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    

    <div class="row">
      <label class="col-sm-2 col-form-label">Task Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select header type"
                             v-model="reso_options.header"
                             name="reso_header"
                             v-validate="modelValidations.reso_header"
                              :error="getErrorCs('reso_header','document')"
                               data-vv-scope="document"
                              @change="onResoDocTypeChange($event)"
                               v-bind:class="{ field_error_cs: errors.has('reso_header','document') }"
                          
                             >
                    <el-option v-for="option in selects.reso_headers"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
            
      </div>
      <div class="col-sm-3 label-on-right">
      	<span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('reso_header','document')">Document Type is required.</span>
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Select Task Type</label>
      <div class="col-sm-7">
        	
        	<!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">AGM/EGM</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==5 }" @click="selectTaskType(5)" style="cursor:pointer;">Notice For AGM/EGM</div>
          			<div v-bind:class="{ ecTaskActive: reso_options.header==8 }" @click="selectTaskType(8)" style="cursor:pointer;">Consent To Short Notice For AGM/EGM</div>
          			<div v-bind:class="{ ecTaskActive: reso_options.header==13 }" @click="selectTaskType(13)" style="cursor:pointer;">Directors' Declaration For AGM</div>
            		<div v-bind:class="{ ecTaskActive: reso_options.header==2 }" @click="selectTaskType(2)" style="cursor:pointer;">EGM (Minutes & Resolution)</div>
            		<div v-bind:class="{ ecTaskActive: reso_options.header==3 }" @click="selectTaskType(3)" style="cursor:pointer;">AGM (Minutes & Resolution)</div>
            
            
            
            </div>
            <!-- end category -->
            
            
            <!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">Directors' Resolution</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==1 }" @click="selectTaskType(1)" style="cursor:pointer;">Directors' Resolution</div>
  
            </div>
            <!-- end category -->
            
            
              <!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">Shares</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==6 }" @click="selectTaskType(6)" style="cursor:pointer;">Share Certificate</div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==9 }" @click="selectTaskType(9)" style="cursor:pointer;">Share Transfer (Standalone Document)</div>
  
            </div>
            <!-- end category -->
            
        
            
            
             <!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">Misc Documents</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==14 }"  @click="selectTaskType(14)" style="cursor:pointer;">Certificate Of Appointment Of Representative</div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==15 }" @click="selectTaskType(15)" style="cursor:pointer;">Striking-off (Balance Sheet 0|0)</div>
  					<div v-bind:class="{ ecTaskActive: reso_options.header==11 }" @click="selectTaskType(11)" style="cursor:pointer;">Nominee Director Agreement</div>
				    <div v-bind:class="{ ecTaskActive: reso_options.header==16 }" @click="selectTaskType(16)" style="cursor:pointer;">Resignation As Secretary/Director/etc</div>

            </div>
            <!-- end category -->
            
            
            
            <!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">Company Onboarding</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==7 }" @click="selectTaskType(7)" style="cursor:pointer;">Company Incorporation</div>
  					<div v-bind:class="{ ecTaskActive: reso_options.header==17 }" style="cursor:pointer;"><span @click="selectTaskType(17)">Form 45 </span><i slot="label" class="nc-icon nc-alert-circle-i"  @mouseover="infoform45" style="font-weight:bold;"></i></div>   
					<div v-bind:class="{ ecTaskActive: reso_options.header==18 }" style="cursor:pointer;"><span @click="selectTaskType(18)">Form 45B </span><i slot="label" class="nc-icon nc-alert-circle-i"  @mouseover="infoform45b" style="font-weight:bold;"></i></div>   
					
            </div>
            <!-- end category -->
            
            
            
                 <!-- start category -->
        	<div style="margin:40px 5px;">
        			<div><span style="font-weight:bold;text-decoration:underline;">Internal Use</span></div>
           	 		<div v-bind:class="{ ecTaskActive: reso_options.header==10 }" style="cursor:pointer;"><span @click="selectTaskType(10)">Company Setup</span><i slot="label" class="nc-icon nc-alert-circle-i" @mouseover="infoCompanySetup" style="font-weight:bold;"></i></div>   

            </div>
            <!-- end category -->
            
            
            
            
            <!--
            
            
            
              reso_headers:[
		   	X  {value: 1, label: 'Directors\' Resolution'},
           X   {value: 2, label: 'EGM (Minutes & Resolution)'},
           X   {value: 3, label: 'AGM (Minutes & Resolution)'},
            X  {value: 13, label: 'Directors\' Declaration For AGM'},
           X   {value: 5, label: 'Notice For AGM/EGM'},
           X   {value: 8, label: 'Consent To Short Notice For AGM/EGM'},
           X    {value: 6, label: 'Share Certificate'},
           X   {value: 9, label: 'Share Transfer'},
           X   {value: 11, label: 'Nominee Director Agreement'},
              {value: 12, label: 'Appointment Of Company Secretary'},
          X    {value: 14, label: 'Certificate Of Appointment Of Representative'},
           X   {value: 7, label: 'Company Incorporation'},
            X  {value: 10, label: 'Company Setup - Internal'},
          X     {value: 15, label: 'Striking-off (Balance Sheet 0|0)'},
               
            
            -->
            
      </div>
      <div class="col-sm-3 label-on-right">
      	<span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('reso_header','document')">Document Type is required.</span>
      </div>
    </div>
    
    
    
    


     <div class="row">
      <label class="col-sm-2 col-form-label">Document Date</label>
      <div class="col-sm-7">
      <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="reso_options.docu_date"
              	name="docu_date"
              	 type="date" placeholder="Select A Date"
              	 v-validate="modelValidations.docu_date"
              	  :error="getErrorCs('docu_date','document')"
              	  data-vv-scope="document"	
              	 v-bind:class="{ field_error_cs: errors.has('docu_date','document') }"
                              >
              </el-date-picker>
              <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('docu_date','document')">Document date is required.</span>
      </div>
      <div class="col-sm-3 label-on-right">
      	
      </div>
    </div>
    
    
     <div class="row" v-if="reso_options.header == 5 || reso_options.header == 8" style="margin-top:50px;">
        <label class="col-sm-2 col-form-label">Meeting Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             v-model="reso_options.meeting_type"
                             name="meeting_type"
							 @change="onMeetingTypeChange($event)"
                          
                             >
                    <el-option v-for="option in selects.meeting_type"
                               class="select-danger"
                               :value="option.value"
                    
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
            
      </div>
      </div>
      
      
      

          	 
	<div class="row" v-if="reso_options.header == 5 " style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Agenda</label>
      <div class="col-sm-7">
      		<p-checkbox style="margin-bottom:15px;margin-top:15px;" 
          	 v-model="reso_options.agenda_general"  >
          	 <span>Default (For AGM)</span>
       	  </p-checkbox> 	
       	  
       	  
       	  
         
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row" v-if="reso_options.header == 3 " style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Reappointment Of Director(s) Statement</label>
      <div class="col-sm-7">
      		<p-checkbox style="margin-bottom:15px;margin-top:15px;" 
          	 v-model="reso_options.statement_reappointment_directors"  >
          	 <span>Yes</span>
       	  </p-checkbox> 	
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row" v-if="reso_options.header == 13 " style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Directors' Declaration</label>
      <div class="col-sm-7">
      		<p-checkbox style="margin-bottom:15px;margin-top:15px;" 
          	 v-model="reso_options.statement_small_company"  >
          	 <span>Small company exempt from audit requirements</span>
       	  </p-checkbox> 	
       	  
       	  <p-checkbox style="margin-bottom:15px;margin-top:15px;" 
          	 v-model="reso_options.statement_dormant_company_exempt_audit"  >
          	 <span>Company is dormant and exempt from audit requirements </span>
       	  </p-checkbox> 	
       	  
       	  
       	   <p-checkbox style="margin-bottom:15px;margin-top:15px;" 
          	 v-model="reso_options.statement_dormant_company_exempt_fs"  >
          	 <span> Dormant relevant company exempt from preparing financial statements </span>
       	  </p-checkbox> 	
       	  
       	  
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row" v-if="reso_options.header == 14 && 0" style="margin-top:50px;"> <!-- to be removed -->
      <label class="col-sm-2 col-form-label">Name Of Representative</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="appt_rep_name"

                  v-model="reso_options.appt_rep_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    

    <div class="row" v-if="reso_options.header == 5 || reso_options.header == 8" style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Meeting Venue</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="meeting_venue"

                  v-model="reso_options.meeting_venue">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

     <div class="row" v-if="reso_options.header == 5 || reso_options.header == 8" style="margin-top:10px;">
      <label class="col-sm-2 col-form-label">Meeting Date</label>
      <div class="col-sm-7">
        <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="reso_options.meeting_date" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


     <div class="row" v-if="reso_options.header == 5 || reso_options.header == 8" style="margin-top:10px;">
      <label class="col-sm-2 col-form-label">Meeting Time</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="meeting_time"

                  v-model="reso_options.meeting_time">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div v-if="displayRType==3" class="row">
      <label class="col-sm-2 col-form-label">AGM Option: Audited Financial Statements</label>
      <div class="col-sm-7">
        <fg-input style="padding-top:10px;padding-bottom:10px;">
                  <el-select class="select-primary"
                             size="large"
                             id="agm_audited"
                             placeholder="Are the financial statments audited?"
                             v-model="reso_options.agm_audited">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
      <div v-if="reso_options.header==11 || reso_options.header==16" class="row" style="margin-top:10px;background-color:#f7f7f7;padding-top:50px;padding-bottom:40px;">
      <label class="col-sm-2 col-form-label">People Search By Gov ID/Passport
      		<span v-if="reso_options.header==11" >(Nominee Director)</span>
      	 	<span v-if="reso_options.header==16" >(Secretary/Director/etc)</span>
      
      </label>
      <div class="col-sm-7">
      	  	    <fg-input type="text"
                  		name="search_generic_person_id_num"
                 	    v-model="search_generic_person_id_num"
                 	    style="max-width:500px;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('generic_person')">Search People</p-button>
			   
			   <div v-if="generic_person1_found" style="margin-bottom:50px;" >
			   	   <div style="margin-top:50px;margin-bottom:20px;font-weight:bold;color:green">Person Found</div>
			   	  <div><strong>Name:</strong> {{generic_person1.person.first_name}} {{generic_person1.person.last_name}}</div>
			   	  <div><strong>Address:</strong> {{generic_person1.person.address_1}}</div>
			   	  <div><strong>ID:</strong> {{generic_person1.person.gov_id}}</div>
			   
			   </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    
    
      <div v-if="reso_options.header==14" class="row" style="margin-top:10px;background-color:#f7f7f7;padding-top:50px;padding-bottom:40px;">
      <label class="col-sm-2 col-form-label">Company (Listed Under "People" Database) Search By Company Registration Number      
     					<br/><br/><span>(Certificate Of Appointment Of Representative)</span>
      </label>
      <div class="col-sm-7">
      	  	    <fg-input type="text"
                  		name="search_generic_company_id_num"
                 	    v-model="search_generic_company_id_num"
                 	    style="max-width:500px;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchCompany('generic')">Search Company</p-button>
			   
			   <div v-if="generic_company_found" style="margin-bottom:50px;" >
			   	   <div style="margin-top:50px;margin-bottom:20px;font-weight:bold;color:green">Company Found</div>
			   	  <div><strong>Company Name:</strong> {{sh_coy.company_info.company_name}}</div>
			   	  <div><strong>Company Address:</strong> {{sh_coy.company_info.address}}</div>
			   	   <div><strong>Company Registration Number:</strong> {{sh_coy.company_info.company_reg_num}}</div>
			   	   <br/>
			   	  <div><strong>Authorized Representative:</strong> 
			   	  <span v-if="sh_coy.person==null">Please add an authorized representative for this company in the "People" database first before generating the document.</span>
			   	  <span v-else>
			   	  {{sh_coy.person.first_name}} {{sh_coy.person.last_name}}
			   	  ({{sh_coy.person.gov_id}})</span>
			   	  </div>
			   
			   </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    <!-- end -->
    
    
    
    <div class="row" v-if="reso_options.header == 16" style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Position Person Is Resigning From</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="resignation_position"
                  v-model="reso_options.resignation_position">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    
     <div class="row" v-if="reso_options.header == 11" style="margin-top:50px;">
      <label class="col-sm-2 col-form-label">Name Of Company's Representative</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_rep"

                  v-model="reso_options.company_rep">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     




     <div class="row" style="margin-top:10px;">
      <label class="col-sm-2 col-form-label">Document Sub-header</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="sub-header"
                  v-model="reso_options.sub_header">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      	<code>optional</code>
      </div>
    </div>


    </card>
    <!-- end resolution options -->

    <card>
  	 <!-- start: for creating share certs-->
			 <div v-if="displayRType==2 && displaySelectShareCert" style="text-align:center;margin-top:30px;">



			  <div   style="width:350px;margin-left:auto;margin-right:auto;">

			 	<div style="margin:15px 0px;font-weight:bold;font-size:14px;">Select The Shareholder</div>
			 	<!-- shareholders list-->
			   <div v-for="(sh, index) in shareholders_list_full" style="margin:15px 0px;">
			 		<a v-if="sh.pivot.num_shares>0" @click="addShareCert(index)" style="cursor:pointer;">
			 		<span v-if="sh.person">
			 			{{sh.person.first_name}}  {{sh.person.last_name}} ( {{sh.person.gov_id}}) :: {{sh.pivot.num_shares}} {{sh.share_type_str}} Shares
			 		</span>
			 		<span v-if="sh.shareholder_company">
			 			{{sh.shareholder_company.company_name}} ( {{sh.shareholder_company.company_reg_num}}) :: {{sh.pivot.num_shares}} {{sh.share_type_str}} Shares
			 		</span>
			 	  </a>
			 	</div>
                 </div>
                <!-- end sharehlders list -->




			  </div>
			<!-- end: for creating share certs-->

  </card>
  
  
  
  <div class="row" >
      <div class="col-md-8" >
  <card>
 <h5 class="title">  People : Quick Search</h5>
     
     
     <div class="row" style="margin-top:10px;">
      <label class="col-sm-3 col-form-label">Search By Name Or ID</label>
      <div class="col-sm-7">
        <fg-input type="text"
        		   @input="qsearchPerson_onkey"
                  name="people_qsearch"
                  v-model="people_qsearch">
        </fg-input>
      </div>
   
    </div>
  
  	<!-- <p-button  type="info" @click.prevent="qsearchPerson()">Search</p-button>-->
     <div v-if="qsearch_result_init ==1" style="margin-top:50px;">
  	 	<el-table :data="qsearch_result">
                <el-table-column label="First Name" property="first_name" ></el-table-column>
                 <el-table-column label="Last Name" property="last_name" ></el-table-column>
                  <el-table-column label="ID No." property="gov_id" ></el-table-column>
     			 <el-table-column label="Email" property="email" ></el-table-column>
                 
            </el-table>
        
        <div style="text-align:center;margin:15px 0px 15px 0px;">
			 <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      			 @click="hideQsearchResults()">(Hide)</span>
      			 </div>
  		</div>
  </card>
  	</div>
	</div><!-- end of row -->
  
  

  <div v-if="displayRType==1 || displayRType==3" style="margin-top:80px;">
   <h4 class="title">Select Changes & Items To Include</h4>
 </div>
 
 
  


   <div class="row" >
      <div class="col-md-6" >
      
     
  
	   <card style="width:100%;padding-bottom:50px;padding-top:50px;margin-top:18px;"  v-if="displayRType==1 || displayRType==3">


 <tabs  pills  type="danger" icons centered tab-content-classes="tab-space" >
	<tab-pane id="general" key="general">
	  <span slot="title">
		Company
	  </span>


		 <div style="text-align:center;margin-top:50px;">
		 	<h5 style="text-decoration:underline;">Change: Company Info</h5>

			 <div @click="includeReso('ch_coy_address')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Change company address</div>
			 <div @click="includeReso('ch_coy_name')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Change company name</div>
			 <div @click="includeReso('ch_coy_fye')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Change financial year-end date</div>
			 <div @click="includeReso('ch_coy_activity')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Change company principal activities</div>
			 <div @click="addCoyInfoChange('ch_strike_off')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Strike-off Company</div>

		 </div>
	</tab-pane>
	<tab-pane id="cofficers" key="cofficers">
	  <span slot="title">
		Officers
	  </span>


		 <!-- start officer change-->
		  <div style="text-align:center;margin-top:50px;">
		 	<h5 style="text-decoration:underline;">Change: Officers</h5>

			 <div @click="includeReso('ch_officer')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Appointment or resignation of officer</div>


			 <div v-if="displayOfficerSearch" style="text-align:center;">
			  <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">
			  <div style="margin-bottom:13px;">Govt ID/Passport Number</div>
				   <fg-input type="text"
                  		name="search_officer_id_num"
                 	    v-model="search_officer_id_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('officer')">Search</p-button>
			   <br/>
			    <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideOfficerSearch()">Hide</span>
			  </div>


			</div>


		 </div>
		 <!-- end officer change-->
		</tab-pane>


	<tab-pane id="cshareholders" key="cshareholders">
	  <span slot="title">
		Shareholders/Members
	  </span>

		 <!-- start shareholder transaction-->
		  <div style="text-align:center;margin-top:50px;">
		  	<div v-if="coy.company_type!=7">
		 	<h5 style="text-decoration:underline;">Change: Shares</h5>

			 <div @click="includeReso('st')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Allotment Of New Shares</div>
			 
			 <div @click="add_share_transfer()" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Share Transfer (AGM/EGM)</div>
			 
		     <div style="padding:10px 0px;">* For the standalone Share Transfer document, please select "Share Transfer" under <span style="">Task Type</span> *</div>
			</div>
			
			<!-- start search -->
			 <div v-if="displayShareholderSearch" style="text-align:center;">
			  <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">
			  <div style="margin-bottom:13px;">Govt ID/Passport Number</div>
				   <fg-input type="text"
                  		name="search_shareholder_id_num"
                 	    v-model="search_shareholder_id_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('shareholder')">Search People</p-button>
			   </div>
			   
			   <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">

			    <div style="margin-bottom:13px;">Company Registration Number</div>
				   <fg-input type="text"
                  		name="search_shareholder_company_reg_num"
                 	    v-model="search_shareholder_company_reg_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchShareholderCompany()">Search For Shareholder Company</p-button>
				

			    
			    
			  </div>
				<div style="text-align:center;">
					<span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideShareholderSearch()">Hide</span>
				</div>

			</div>
			<!-- end search -->
			
			<div v-if="coy.company_type==7">
		 	 <h5 style="text-decoration:underline;margin-top:50px;">Change: Member</h5>
			
			 <div @click="includeReso('mc')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Add/Remove Member</div>
			 </div>
			 
			 <!-- start search -->
			 <div v-if="displayMemberSearch" style="text-align:center;">
			  <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">
			  <div style="margin-bottom:13px;">Govt ID/Passport Number</div>
				   <fg-input type="text"
                  		name="search_member_id_num"
                 	    v-model="search_member_id_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('member')">Search People</p-button>
			   </div>
			   
			   <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">

			    <div style="margin-bottom:13px;">Company Registration Number</div>
				   <fg-input type="text"
                  		name="search_member_company_reg_num"
                 	    v-model="search_member_company_reg_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchMemberCompany()">Search For Company</p-button>
				

			    
			    
			  </div>
				<div style="text-align:center;">
					<span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideMemberSearch()">Hide</span>
				</div>

			</div>
			<!-- end search -->


		 </div>
		 <!-- end shareholder/member transaction-->
		</tab-pane>

	<tab-pane id="csharecert" key="csharecert">
	  <span slot="title">
		Share Certs
	  </span>



		 <!-- start share certs-->
		  <div style="text-align:center;margin-top:50px;">
		 	<h5 style="text-decoration:underline;">Shares Certificates</h5>

		 	 <!--<div @click="includeReso('create_sc')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Create share certificate</div>-->
			 <div @click="includeReso('issue_sc')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Issue share certificate (via resolution)</div>
			 <div @click="includeReso('cancel_sc')" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Cancel share certificate (via resolution)</div>





			<!-- start: for canceling share certs-->
			  <div v-if="displayCancelShareCertSelect" style="width:350px;margin-left:auto;margin-right:auto;">
			    <div>
			 	<div style="margin:15px 0px;text-decoration:underline;margin-top:50px;">Select Share Certificate To Cancel</div>
			 	<!-- shareholders list-->
			   <div v-for="(sc, index) in share_certs_list_full" style="margin:15px 0px;margin-bottom:30px;">
			 	  <div  @click="initCancelShareCert(index)" style="cursor:pointer;padding:10px 10px;border:1px solid #ccc">
			 		<span style="font-weight:bold">
			 		#{{sc.cert_number}} </span>

			 		<span v-if="sc.shareholder.person">
			 		{{sc.shareholder.person.first_name}}  {{sc.shareholder.person.last_name}} ( {{sc.shareholder.person.gov_id}})
			 		</span>

			 		<span v-if="sc.shareholder.shareholder_company">
			 		{{sc.shareholder.shareholder_company.company_name}}  ( {{sc.shareholder.shareholder_company.company_reg_num}})
			 		</span>

			 		<br/> {{sc.num_shares}} {{sc.share_type_str}} Shares
			 	  </div>

			 	</div>
                </div>
                <!-- end sharehlders list -->
				<div v-if="share_certs_list_full.length==0" style="padding: 20px;color: red;font-weight: bold;">- No Share Certificates Found -</div>
				
			    <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideCancelShareCertSelect()">Hide</span>
			  </div>
			<!-- end: for canceling share certs-->


			<!-- start: for issuing share certs-->
			  <div v-if="displayIssueShareCertSelect" style="width:350px;margin-left:auto;margin-right:auto;">
			    <div>
			 	<div style="margin:15px 0px;text-decoration:underline;margin-top:50px;">Select Share Certificate To Issue</div>
			 	<!-- shareholders list-->
			   <div v-for="(sc, index) in share_certs_list_full" style="margin:15px 0px;margin-bottom:30px;">
			 	  <div  @click="initIssueShareCert(index)" style="cursor:pointer;padding:10px 10px;border:1px solid #ccc">
			 		<span style="font-weight:bold">#{{sc.cert_number}} </span>


					<span v-if="sc.shareholder.person">
			 		{{sc.shareholder.person.first_name}}  {{sc.shareholder.person.last_name}} ( {{sc.shareholder.person.gov_id}})
			 		</span>

			 		<span v-if="sc.shareholder.shareholder_company">
			 		{{sc.shareholder.shareholder_company.company_name}}  ( {{sc.shareholder.shareholder_company.company_reg_num}})
			 		</span>


			 		<br/> {{sc.num_shares}} {{sc.share_type_str}} Shares
			 	  </div>

			 	</div>
                </div>
                <!-- end sharehlders list -->
                <div v-if="share_certs_list_full.length==0" style="padding: 20px;color: red;font-weight: bold;">- No Share Certificates Found -</div>

			    <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideIssueShareCertSelect()">Hide</span>
			  </div>
			<!-- end: for issuing share certs-->




		 </div>
		 <!-- end share certs-->
	 </tab-pane>

	 <tab-pane id="add_misc_items" key="add_misc_items">
	  <span slot="title">
		Misc
	  </span>

	   <div style="text-align:center;margin-top:50px;">
		 	<h5 style="text-decoration:underline;">Misc</h5>

	 		 <div @click="addCustomResoItem()" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Add Custom Item</div>
	 		 <div @click="addCloseBankAccount()" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Close Bank Account</div>
	 		 <div @click="addOpenBankAccount()" style="cursor:pointer;font-weight:bold;padding:10px 0px;">Open Bank Account</div>
	 	</div>
	 </tab-pane>

	 </tabs>

		</card>
		
		 
      <div v-if="displayRType==9 || show_share_transfer_form == 1" style="margin-top:80px;">
   <h4 class="title">Who Is Receiving The Shares?</h4>
 </div>
      
      	<!-- start: share transfer -->
        <card v-if="displayRType==9 ||  show_share_transfer_form == 1">
  			<div  style="text-align:center;">
			  <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">
			  <div>Govt ID/Passport Number</div>
				   <fg-input type="text"
                  		name="search_shareholder_id_num"
                 	    v-model="search_shareholder_id_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('shareholder')">Search People</p-button>
			  </div>
			  
			  <div style="border: ;margin: 50px;padding: 30px;background-color: #f0f0f0;">

			    <div>Company Registration Number</div>
				   <fg-input type="text"
                  		name="search_shareholder_company_reg_num"
                 	    v-model="search_shareholder_company_reg_num"
                 	    style="max-width:500px;margin-left:auto;margin-right:auto;"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchShareholderCompany()">Search For Shareholder Company</p-button>


				  </div>


			</div>

  </card>
   	<!-- end: share transfer -->
  
  
  
   </div>  <!-- end left col -->

   <!-- start right col -->
    <div class="col-md-6" >





   <!-- start coy info fields-->
   <card    style="">



   <div v-if="resolutions.ch_coy_address">



       <div class="row" style="margin-top:30px;">
      	<label class="col-sm-2 col-form-label">New Company Address</label>
		  <div class="col-sm-7">
				<fg-input type="text"
					  name="coy_address"
					  v-model="coyInfo.address">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code>required</code>
		  </div>
       </div>


        <div style="text-align:center;">
		  <p-button type="danger"  @click="addCoyInfoChange('ch_address')" >
					<i slot="label"></i>
					Add Change: New Company Address
		 </p-button>
     		  <div>
      	 		<span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="excludeReso('ch_coy_address')">Hide</span>
    		  </div>
    	 </div>

    </div>


     <div v-if="resolutions.ch_coy_name" class="row">
      <label class="col-sm-2 col-form-label">New Company Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="coy_name"
                  v-model="coyInfo.coy_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      	 <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="excludeReso('ch_coy_name')">Hide</span>
      </div>

      <div style="margin-left:auto;margin-right:auto;">
      <p-button type="danger"  @click="addCoyInfoChange('ch_coy_name')" >
                <i slot="label"></i>
                Add Change: New Company Name
     </p-button>
     </div>

    </div>


    <div  v-if="resolutions.ch_coy_fye"  class="row">
      <label class="col-sm-2 col-form-label">New Financial Year-End Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="coyInfo.fye" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      	<span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="excludeReso('ch_coy_fye')">Hide</span>
      </div>
      
      <div style="margin-left:auto;margin-right:auto;">
		  <p-button type="danger"  @click="addCoyInfoChange('ch_coy_fye')" >
					<i slot="label"></i>
					Add Change: New FYE Date
		 </p-button>
     </div>
      
    </div>
    
    
    
    
    <div  v-if="resolutions.ch_coy_activity">
		 <div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (I) Code</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_1_code">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			 <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="excludeReso('ch_coy_activity')">Hide</span>
		  </div>
		</div>
		
		
		<div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (I) Title</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_1_title">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (I) Description</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_1_desc">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		<div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (II) Code</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_2_code">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (II) Title</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_2_title">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row">
		  <label class="col-sm-2 col-form-label">New Principal Activity (II) Description</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="coyInfo.principal_activity_2_desc">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
	
	
		 <div style="text-align:center;">
		  <p-button type="danger"  @click="addCoyInfoChange('ch_coy_activity')" >
					<i slot="label"></i>
					Add Change: New Company Activities
		 </p-button>
		 </div>
    </div> <!-- end change company activity-->
    
    


   </card>
   <!-- end coy info fields-->


 <!-- start: add custom item form -->
 <card v-if="displayAddCustomItemForm" class="form-horizontal" style="">

	 <div  class="row">
      <label class="col-sm-2 col-form-label">New Resolution Item</label>
      <div class="col-sm-7">
        <textarea
        		 cols="45" rows="10"
                  name="new_reso_item"
                  v-model="new_reso_item">
        </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
      	 <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideCustomResoItem">Hide</span>
      </div>

      <div style="margin-left:auto;margin-right:auto;">
      <p-button type="danger"  @click="addNewResoItem()" >
                <i slot="label"></i>
                Add New Resolution Item
     </p-button>
     </div>

    </div>


</card>
 <!-- end: add custom item form -->


  <!-- start: add close bank form form -->
 <card v-if="showCloseBankAccountForm" class="form-horizontal" style="">

	 <div class="row">
      <label class="col-sm-2 col-form-label">Bank Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="closeBankAccount.name"
                  v-model="closeBankAccount.name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-2 col-form-label">Bank Account Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="closeBankAccount.acNumber"
                  v-model="closeBankAccount.acNumber">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
      </div>




      <div style="margin-left:auto;margin-right:auto;width:100%;text-align:center;">
      <p-button type="danger"  @click="addCloseBankAccountItem()" >
                <i slot="label"></i>
                Add Item
     </p-button>
     <br/>
      <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideCloseBankAccount">Hide</span>
     </div>



</card>
 <!-- end: add custom item form -->
 
 
 
   <!-- start: add open bank form form -->
 <card v-if="showOpenBankAccountForm" class="form-horizontal" style="">

	 <div class="row">
      <label class="col-sm-2 col-form-label">Bank Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="reso_options.open_bank_name"
                  v-model="reso_options.open_bank_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-2 col-form-label">Authorized Person(s)</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="reso_options.open_bank_authorized"
                  v-model="reso_options.open_bank_authorized">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
     <span style="font-size:11px;"> e.g. John Lim and Tim Tan</span>
      </div>
      </div>




      <div style="margin-left:auto;margin-right:auto;width:100%;text-align:center;">
      <p-button type="danger"  @click="addOpenBankAccountItem()" >
                <i slot="label"></i>
                Add Item
     </p-button>
     <br/>
      <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="hideOpenBankAccount">Hide</span>
     </div>



</card>
 <!-- end: add open bank form -->


<!-- start: add new cancel share cert form -->

<card v-if="displayCancelShareCertForm" class="form-horizontal" style="">
	 <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Cancel Share Certificate</span>
    </h5>

<div style="margin-top:50px;text-align:center;">
<span style="font-weight:bold">Cancel Share Certificate #{{cancel_share_cert_init.cert_number}} </span>

<span v-if="cancel_share_cert_init.shareholder.person">
{{cancel_share_cert_init.shareholder.person.first_name}}  {{cancel_share_cert_init.shareholder.person.last_name}} ( {{cancel_share_cert_init.shareholder.person.gov_id}})
</span>

<span v-if="cancel_share_cert_init.shareholder.shareholder_company">
{{cancel_share_cert_init.shareholder.shareholder_company.company_name}}  ( {{cancel_share_cert_init.shareholder.shareholder_company.company_reg_num}})
</span>




			 		:: {{cancel_share_cert_init.num_shares}} {{cancel_share_cert_init.share_type_str}} Shares
</div>

 <div class="row" style="margin-top:30px; margin-bottom:60px;">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="cancel_share_cert_init.effective_date" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

     <div style="text-align:center;margin-top:50px;">


     <p-button type="danger"  @click="cancelShareCert()" >
                <i slot="label"></i>
                Add Change: Cancel Share Certificate
     </p-button>

	</div>

</card>
<!-- end: add new cancel share cert form -->


<!-- start: add new issue share cert form -->

<card v-if="displayIssueShareCertForm" class="form-horizontal" style="">
	 <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Issue Share Certificate</span>
    </h5>

<div style="margin-top:50px;text-align:center;">
<span style="font-weight:bold">Issue Share Certificate #{{issue_share_cert_init.cert_number}} </span>


<span v-if="issue_share_cert_init.shareholder.person">
{{issue_share_cert_init.shareholder.person.first_name}}  {{issue_share_cert_init.shareholder.person.last_name}} ( {{issue_share_cert_init.shareholder.person.gov_id}})
</span>

<span v-if="issue_share_cert_init.shareholder.shareholder_company">
{{issue_share_cert_init.shareholder.shareholder_company.company_name}}  ( {{issue_share_cert_init.shareholder.shareholder_company.company_reg_num}})
</span>

 :: {{issue_share_cert_init.num_shares}} {{issue_share_cert_init.share_type_str}} Shares
</div>

 <div class="row" style="margin-top:30px; margin-bottom:60px;">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
             <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="issue_share_cert_init.effective_date" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

     <div style="text-align:center;margin-top:50px;">


     <p-button type="danger"  @click="issueShareCert()" >
                <i slot="label"></i>
                Add Change: Issue Share Certificate
     </p-button>

	</div>

</card>
<!-- end: add new issue share cert form -->

<!-- start officer1 -->
<card v-if="officer1_found" class="form-horizontal" style="">
    <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Officer &nbsp;   <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      																			 @click="hideAddNewChangeOfficer()">(Hide)</span>
      
      
      
      </span> 
    </h5>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer1.person.first_name}}  {{officer1.person.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer1.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer1.person.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer1.person.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div style="margin-top:60px;">
    <h4 slot="header" class="card-title">
        Officer Change Details
    </h4>
    </div>


     <div class="row">
      <label class="col-sm-2 col-form-label">New Officer Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="officer1.status">
                    <el-option v-for="option in selects.officer_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>




    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="officer1.effective_date" type="date" placeholder="Select A Date"                
              	  name="effective date"
              	  
              	   v-validate="'required'"
				  data-vv-scope="addOfficer"
              	  :error="getErrorCs('effective date','addOfficer')"
              	 v-bind:class="{ field_error_cs: errors.has('effective date','addOfficer') }"

                 >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>

	 <div class="row">
      <label class="col-sm-2 col-form-label">Position</label>
      <div class="col-sm-7">
       <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Position"
                             v-model="officer1.position">
                    <el-option v-for="option in selects.officer_position"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div class="row">
      <label class="col-sm-2 col-form-label">Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="officer title"
				  v-validate="'required'"
				  data-vv-scope="addOfficer"
				  :error="getErrorCs('officer title','addOfficer')"
                  v-model="officer1.title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


     <div class="row">
      <label class="col-sm-2 col-form-label">Is This Person The Point-of-Contact?</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select"
                             v-model="officer1.isContactPerson">
                    <el-option v-for="option in selects.yesno"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>



    <div style="text-align:center;margin-top:50px;">


     <p-button type="danger"  @click="validateAddOfficer()" >
                <i slot="label" class=""></i>
                Add Change: Officer
     </p-button>

	</div>
</card>

<!-- end officer1 -->



<!-- start member1 -->
<card v-if="member1_found" class="form-horizontal" style="">
    <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Member (Individual) &nbsp;   <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      																			 @click="hideAddNewChangeMember()">(Hide)</span>
      
      </span>
    </h5>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_"> {{member1.person.first_name}}  {{member1.person.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{member1.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{member1.person.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{member1.person.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div style="margin-top:60px;">
    <h4 slot="header" class="card-title">
        Member Change Details
    </h4>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">New Member Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="member1.status"
                              name="member status"
                              data-vv-scope="addMember"
              				  v-bind:class="{ field_error_cs: errors.has('member status','addMember') }"                            
              				  v-validate="'required'"
                             >
                    <el-option v-for="option in selects.officer_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    


     <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="member1.effective_date" type="date" placeholder="Select A Date"
              	  name="effective date"
                 data-vv-scope="addMember"
                 v-bind:class="{ field_error_cs: errors.has('effective date','addMember') }"                            
                v-validate="'required'"
				>
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>



    <div style="text-align:center;margin-top:50px;">
      <p-button type="danger"  @click="validateAddMember()" >
                <i slot="label" ></i>
                Add Change: Member
     </p-button>
	</div>
</card>

<!-- end member1 -->


<!-- start m_coy -->
<card v-if="m_coy_found" class="form-horizontal" style="">
    <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Member (Company)  &nbsp;   <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      																			 @click="hideAddNewChangeMemberCompany()">(Hide)</span>
      
      </span>
    </h5>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Representative Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_"> {{m_coy.person.first_name}}  {{m_coy.person.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{m_coy.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Company Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{m_coy.company_info.company_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Company Registration Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{m_coy.company_info.company_reg_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div style="margin-top:60px;">
    <h4 slot="header" class="card-title">
        Member Change Details
    </h4>
    </div>

   <div class="row">
      <label class="col-sm-2 col-form-label">New Member Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="m_coy.status"
                              name="member company status"
                              data-vv-scope="addMemberCompany"
              				  v-bind:class="{ field_error_cs: errors.has('member company status','addMemberCompany') }"                            
              				  v-validate="'required'"
                             >
                    <el-option v-for="option in selects.officer_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    


     <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="m_coy.effective_date" type="date" placeholder="Select A Date"
              	  name="effective date"
                 data-vv-scope="addMemberCompany"
                 v-bind:class="{ field_error_cs: errors.has('effective date','addMemberCompany') }"                            
                v-validate="'required'"
				>
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>




    <div style="text-align:center;margin-top:50px;">
      <p-button type="danger"  @click="validateAddMemberCompany()" >
                <i slot="label" class="nc-icon"></i>
                Add Change: Member (Company)
     </p-button>
	</div>
</card>

<!-- end m_coy -->


<!-- start sh1 -->
<card v-if="sh1_found" class="form-horizontal" style="">
    <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Shareholder (Individual) &nbsp;   <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      																			 @click="hideAddNewChangeShareholder()">(Hide)</span>
      
      </span>
    </h5>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_"> {{sh1.person.first_name}}  {{sh1.person.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh1.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh1.person.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh1.person.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div style="margin-top:60px;">
    <h4 slot="header" class="card-title">
        Share Transaction Details
    </h4>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Share Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Type"
                             v-model="sh1.share_type"

                             >
                    <el-option v-for="option in selects.share_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Number Of Shares</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  v-model="sh1.num_shares"                  
                  v-validate="'required'"
              	  name="number of shares"
                 data-vv-scope="addShareT"
                 :error="getErrorCs('number of shares','addShareT')"
                  
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


     <div class="row">
      <label class="col-sm-2 col-form-label">Transaction Type</label>
      <div class="col-sm-7">
      	<fg-input v-if="sh1.transaction_type==4" value="Transfer To Another Shareholder" disabled></fg-input>
        <fg-input v-if="sh1.transaction_type!=4">
                  <el-select class="select-primary"
                             size="large"
                             @change="onTransactionTypeChange($event)"
                             placeholder="Select Type"
                             v-model="sh1.transaction_type"

                             >
                    <el-option v-for="option in selects.transaction_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div v-if="showTransferFrom" class="row">
      <label class="col-sm-2 col-form-label">Transfer Shares From</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Shareholder"
                             v-model="sh1.transfer_tofrom_id">
                    <el-option v-for="option in selects.shareholders_list"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>



     <div v-if="displayPaidUpCap" class="row">
      <label class="col-sm-2 col-form-label">Paid-up Capital</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="paid_up_capital"
                  v-model="sh1.paid_up_capital">
        </fg-input>        
         <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Currency"
                             v-model="sh1.currency"

                             >
                    <el-option v-for="option in selects.currencies"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
        
      </div>
      <div class="col-sm-3 label-on-right">
       <code></code>
      </div>
    </div>

     <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="sh1.effective_date" type="date" placeholder="Select A Date"
              	  name="effective date"
                 data-vv-scope="addShareT"
                 v-bind:class="{ field_error_cs: errors.has('effective date','addShareT') }"
                             
                v-validate="'required'"
				>
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>



    <div style="text-align:center;margin-top:50px;">
      <p-button type="danger"  @click="validateAddShareholder('i')" >
                <i slot="label" ></i>
                Add Change: Shareholder
     </p-button>
	</div>
</card>

<!-- end sh1 -->




<!-- start sh_coy -->
<card v-if="sh_coy_found" class="form-horizontal" style="">
    <h5  slot="header" class="card-title" style="">
      <span style="font-weight:bold;">Add New Change: Shareholder (Company)  &nbsp;   <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;'
      																			 @click="hideAddNewChangeShareholderCompany()">(Hide)</span>
      
      </span>
    </h5>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Representative Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_"> {{sh_coy.person.first_name}}  {{sh_coy.person.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh_coy.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Company Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh_coy.company_info.company_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label " >Company Registration Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{sh_coy.company_info.company_reg_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    <div style="margin-top:60px;">
    <h4 slot="header" class="card-title">
        Share Transaction Details
    </h4>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Share Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Type"
                             v-model="sh_coy.share_type"

                             >
                    <el-option v-for="option in selects.share_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Number Of Shares</label>
      <div class="col-sm-7">
        <fg-input type="text"                  
                  v-validate="'required'"
              	  name="number of shares"
                 data-vv-scope="addShareTCoy"
                 :error="getErrorCs('number of shares','addShareTCoy')"

                  v-model="sh_coy.num_shares">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


     <div class="row">
      <label class="col-sm-2 col-form-label">Transaction Type</label>
      <div class="col-sm-7">
        <fg-input v-if="sh_coy.transaction_type!=4">
                  <el-select class="select-primary"
                             size="large"
                             @change="onTransactionTypeChange($event)"
                             placeholder="Select Type"
                             v-model="sh_coy.transaction_type"

                             >
                    <el-option v-for="option in selects.transaction_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div v-if="showTransferFrom" class="row">
      <label class="col-sm-2 col-form-label">Transfer Shares From</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Shareholder"
                             v-model="sh_coy.transfer_tofrom_id">
                    <el-option v-for="option in selects.shareholders_list"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>



     <div class="row">
      <label class="col-sm-2 col-form-label">Paid-up Capital</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="paid_up_capital"
                  v-model="sh_coy.paid_up_capital">
        </fg-input>
         <fg-input type="text"
                  name="currency"
                  v-model="sh_coy.currency">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
       <code></code>
      </div>
    </div>

     <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="sh_coy.effective_date" type="date" placeholder="Select A Date"
              	 data-vv-scope="addShareTCoy"
              	 name='effective date'
                 v-bind:class="{ field_error_cs: errors.has('effective date','addShareTCoy') }"
                             
                v-validate="'required'"
              	
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>



    <div style="text-align:center;margin-top:50px;">
      <p-button type="danger"  @click="validateAddShareholder('c')" >
                <i slot="label" class="nc-icon"></i>
                Add Change: Shareholder (Company)
     </p-button>
	</div>
</card>

<!-- end sh_coy -->





    </div>   <!-- end right col -->
</div><!-- end full row -->

<!--start: new changes-->
<h4  class="title">
            You Are Adding The Following:
</h4>
<card style="min-height:30px;" >


<div v-for="(cic, index) in coyInfoChange">

	<div v-if="cic.ch_type=='ch_address'">
		<span style='font-weight:bold;'>[CHANGE] New company address:</span> {{cic.address}}

		 <span style="color:red;cursor:pointer;" @click="removeCoyInfoChange('ch_address', index)" > [Remove]</span>
	</div>


	<div v-if="cic.ch_type=='ch_coy_name'">
		<span style='font-weight:bold;'>[CHANGE] New company name:</span> {{cic.coy_name}}

		 <span style="color:red;cursor:pointer;" @click="removeCoyInfoChange('ch_coy_name', index)" > [Remove]</span>
	</div>
	
	<div v-if="cic.ch_type=='ch_coy_fye'">
		<span style='font-weight:bold;'>[CHANGE] New Financial Year-end Date:</span> {{cic.coy_fye}}

		 <span style="color:red;cursor:pointer;" @click="removeCoyInfoChange('ch_coy_fye', index)" > [Remove]</span>
	</div>
	
	
	<div v-if="cic.ch_type=='ch_coy_activity'">
		<span v-if="cic.coy_pa1_code">
			<span style='font-weight:bold;'>[CHANGE] New Principal Activity I:</span> ({{cic.coy_pa1_code}}) - {{cic.coy_pa1_title}}. {{cic.coy_pa1_desc}}
			<br/>
		</span>
		
		<span v-if="cic.coy_pa2_code">
			<span style='font-weight:bold;'>[CHANGE] New Principal Activity II:</span> ({{cic.coy_pa2_code}}) - {{cic.coy_pa2_title}}. {{cic.coy_pa2_desc}}
		</span>
		 <span style="color:red;cursor:pointer;" @click="removeCoyInfoChange('ch_coy_activity', index)" > [Remove]</span>
	</div>


	<div v-if="cic.ch_type=='ch_strike_off'">
		<span style='font-weight:bold;'>Strike-off Company</span>

		 <span style="color:red;cursor:pointer;" @click="removeCoyInfoChange('ch_strike_off', index)" > [Remove]</span>
	</div>


</div>

<!-- start: new share cert -->
<div v-if="share_cert">

<span style="font-weight:bold;">New Share Certificate:</span>

	<span v-if="share_cert.person"> {{share_cert.person.first_name}}  {{share_cert.person.last_name}} ( {{share_cert.person.gov_id}}) </span>
	<span v-if="share_cert.shareholder_company"> {{share_cert.shareholder_company.company_name}}  ( {{share_cert.shareholder_company.company_reg_num}}) </span>

	:: {{share_cert.pivot.num_shares}} {{share_cert.share_type_str}} Shares


<span style="color:red;cursor:pointer;" @click="removeNewShareCert()" > [Remove]</span>
</div>
<!-- end: new share cert -->

<!--start: new officer changes-->
<div v-for="(oc, index) in officer_changes">
<span style='color:green;font-weight:bold'>[CHANGE]</span>
{{oc.person.first_name}} {{oc.person.last_name}} ({{oc.person.gov_id}}):
  	 		<span v-if="oc.status==1">Appointed</span>
  	 		<span v-if="oc.status==2">Resigned</span>
  	 		 As

  	 		<span v-if="oc.position==1" >Director</span>
  	 		 <span v-if="oc.position==2" >Nominee Director</span>
			 <span v-if="oc.position==3" >Secretary</span>
			 <span v-if="oc.position==4" >Director & Secretary</span>
			 <span v-if="oc.position==5" >Data Protection Officer</span>
			 <span v-if="oc.position==6" >Director & Data Protection Officer</span>

			 	<span > ({{oc.title}})</span>
			<span v-if="oc.effective_date">
  	 		, effective on {{oc.effective_date}}.
  	 		</span>
			<span style="color:red;cursor:pointer;" @click="removeNewOfficerChange(index)" > [Remove]</span>


</div>
<!-- end: new officer changes -->


<!--start: new member changes-->
<div v-for="(mc, index) in member_changes">
<span style='color:green;font-weight:bold'>[CHANGE]</span>
{{mc.person.first_name}} {{mc.person.last_name}} ({{mc.person.gov_id}}):
  	 		<span v-if="mc.status==1">Appointed</span>
  	 		<span v-if="mc.status==2">Resigned</span>
  	 		 as member 
			<span v-if="mc.effective_date">
  	 		, effective on {{mc.effective_date}}.
  	 		</span>
			<span style="color:red;cursor:pointer;" @click="removeNewMemberChange(index)" > [Remove]</span>


</div>
<!-- end: new member changes -->


<!--start: new member company changes-->
<div v-for="(sh, index) in member_company_changes">
	<span style='color:green;font-weight:bold'>[CHANGE]</span>
	{{sh.company_info.company_name}} ({{sh.company_info.company_reg_num}}):
	
	<span v-if="sh.status==1">Appointed</span>
  	 		<span v-if="sh.status==2">Resigned</span>
  	 		
  	as member, on  {{sh.effective_date}}

	<span style="color:red;cursor:pointer;" @click="removeNewMemberCompanyChange(index)" > [Remove]</span>

</div>
<!-- end: new member company changes -->


<!--start: new shareholder changes-->
<div v-for="(sh, index) in shareholder_changes">

	<div v-if="sh.transaction_type==1 || sh.transaction_type==2">
	<span style='color:green;font-weight:bold'>[CHANGE]</span> 
	{{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}}):
  	 		<span v-if="sh.transaction_type==1">Increase</span>
  	 		<span v-if="sh.transaction_type==2">Decrease</span>


  	 		  {{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

  	 		  <span v-if="sh.share_type==1">Ordinary</span>
  	 		  <span v-if="sh.share_type==2">Preference</span>
  	 		   <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>

  	 		  Shares 
  	 		  <span v-if="sh.effective_date">
  	 		  , effective on {{sh.effective_date}}.
			  </span>
  	 		  <span style="color:red;cursor:pointer;" @click="removeNewShareholderChange(index)" > [Remove]</span>
  	 </div>

  	<div v-if="sh.transaction_type==3">
  		<span style='color:green;font-weight:bold'>[CHANGE]</span> 
  		Transferring

  		{{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

  		 <span v-if="sh.share_type==1">Ordinary</span>
  	 	 <span v-if="sh.share_type==2">Preference</span>
  	 	  <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
				  </span>


  		Shares to {{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}})
  		 <span v-if="sh.effective_date">
  		, effective on {{sh.effective_date}}.
		</span>
  		<span style="color:red;cursor:pointer;" @click="removeNewShareholderChange(index)" > [Remove]</span>
  	</div>

</div>
<!-- end: new shareholder changes -->



<!--start: new shareholder company changes-->
<div v-for="(sh, index) in shareholder_company_changes">

	<div v-if="sh.transaction_type==1 || sh.transaction_type==2">
	{{sh.company_info.company_name}} ({{sh.company_info.company_reg_num}}):
  	 		<span v-if="sh.transaction_type==1">Increase</span>
  	 		<span v-if="sh.transaction_type==2">Decrease</span>


  	 		  {{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

  	 		  <span v-if="sh.share_type==1">Ordinary</span>
  	 		  <span v-if="sh.share_type==2">Preference</span>

  	 		  Shares
  	 		   <span v-if="sh.effective_date">
  	 		  , effective on {{sh.effective_date}}.
				</span>
  	 		  <span style="color:red;cursor:pointer;" @click="removeNewShareholderCompanyChange(index)" > [Remove]</span>
  	 </div>

  	<div v-if="sh.transaction_type==3">
  		Transferring

  		{{sh.num_shares}} ({{sh.paid_up_capital}} {{sh.currency}})

  		 <span v-if="sh.share_type==1">Ordinary</span>
  	 	 <span v-if="sh.share_type==2">Preference</span>
  	 	  <span v-for="st in coy.share_types">
				  	  <span v-if="sh.share_type==st.id">{{st.name}}</span>
		 </span>


  		Shares to 
  		
  		<span v-if="sh.is_company==1">
  			{{sh.company_info.company_name}}
  		</span>
  		<span v-else>
  			{{sh.person.first_name}} {{sh.person.last_name}} ({{sh.person.gov_id}})
  		</span>
  		
  		<span v-if="sh.effective_date">
  		, effective on {{sh.effective_date}}.
		</span>
  		<span style="color:red;cursor:pointer;" @click="removeNewShareholderChange(index)" > [Remove]</span>
  	</div>

</div>
<!-- end: new shareholder company changes -->



<!--start: new cancel share certs-->
<div v-for="(sc, index) in cancel_share_certs">
	<span style='color:green;font-weight:bold'>[CHANGE]</span>
	<span style="font-weight:bold">Cancel Share Certificate #{{sc.cert_number}} </span>

	<span v-if="sc.shareholder.person">
	{{sc.shareholder.person.first_name}}  {{sc.shareholder.person.last_name}} ( {{sc.shareholder.person.gov_id}})
	</span>

	<span v-if="sc.shareholder.shareholder_company">
	{{sc.shareholder.shareholder_company.company_name}} ( {{sc.shareholder.shareholder_company.company_reg_num}})
	</span>


			 		:: {{sc.num_shares}} {{sc.share_type_str}} Shares  
			 	 <span v-if="sc.effective_date">
			 		(Eff. {{sc.effective_date}})
			 	</span>	
	<span style="color:red;cursor:pointer;" @click="removeCancelShareCert(index)" > [Remove]</span>
</div>
<!--end: new cancel share certs-->


<!--start: new issue share certs-->
<div v-for="(sc, index) in issue_share_certs">
<span style='color:green;font-weight:bold'>[CHANGE]</span> 
	<span style="font-weight:bold">Issue Share Certificate #{{sc.cert_number}} </span>

	<span v-if="sc.shareholder.person">
	{{sc.shareholder.person.first_name}}  {{sc.shareholder.person.last_name}} ( {{sc.shareholder.person.gov_id}})
	</span>

	<span v-if="sc.shareholder.shareholder_company">
	{{sc.shareholder.shareholder_company.company_name}} ( {{sc.shareholder.shareholder_company.company_reg_num}})
	</span>


			 		:: {{sc.num_shares}} {{sc.share_type_str}} Shares  
			 	  <span v-if="sc.effective_date">
			 		(Eff. {{sc.effective_date}})
			 	</span>	
	<span style="color:red;cursor:pointer;" @click="removeIssueShareCert(index)" > [Remove]</span>
</div>
<!--end: new issue share certs-->


<!--start: new custom reso items-->
<div v-if="displayAddCustomItemNew" style="font-weight:bold;text-decoration:underline;margin:10px 0px;">Custom Resolution Items</div>
<div v-for="(ri, index) in new_reso_items">
	<div>{{index+1}}. {{ri}} <span style="color:red;cursor:pointer;" @click="removeNewResoItem(index)" > [Remove]</span></div> <br/>
</div>
<!--end: new custom reso items-->
</card>
<!--end: new changes-->






<div style="margin-top:150px;">
   <h4 class="title">Who Should Sign The Document (Optional)</h4>
 </div>

 <!-- start: who should sign -->
 <card>



          <div style=''> 
          		<span class="title" style="font-size:21px;">Officers </span> 
          		<span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_officers()" v-if="show_all_officers==false">(Show All Officers)</span>
                <span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_officers_false()" v-if="show_all_officers==true">(Hide Inactive Officers)</span>

          </div>
          
          
          
          <div v-if="noOfficers" style="color: #999;padding: 10px;font-size: 12px;"> - No officers found - </div>
          <div v-for="officer in coy.officers" >

          	<p-checkbox style="margin-bottom:15px;margin-top:15px;" v-if="officer.pivot.status!=2 || show_all_officers == true" :id="officer.id" :value="officer.id"
          	 v-model="selectedOfficers['o'+officer.id]"
          	 :disabled="!officer.person.email"
          	 >
          	  <span style="font-weight:normal">
          		<span style="color:#000">{{officer.person.first_name}} {{officer.person.last_name}}
				- {{officer.person.gov_id}} - 
				
				<span v-if="officer.pivot.status==2 || officer.pivot.status==3" style="color:red;">(Inactive) - </span>
			
          		(
          		<span v-if="officer.pivot.position==1" >Director</span>
  	 		 	<span v-if="officer.pivot.position==2" >Nominee Director</span>
			 	<span v-if="officer.pivot.position==3" >Secretary</span>
			 	<span v-if="officer.pivot.position==4" >Director & Secretary</span>
			 	<span v-if="officer.pivot.position==5" >Data Protection Officer</span>
			 	<span v-if="officer.pivot.position==6" >Director & Data Protection Officer</span>
			 	 |  {{officer.pivot.title}}
			 	)

          		</span>
          		<span v-if="officer.person.email" style="color:#000">- {{officer.person.email}}</span>
          		</span>
          		</p-checkbox>
          </div>
		
		 <div v-if="coy.company_type!=7" stye="margin-bottom:50px;">
          <div style='margin-top:50px;'> 
          		<span class="title" style="font-size:21px;">Shareholders </span> 
          		<span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_shareholders()" v-if="show_all_shareholders==false">(Show All Shareholders)</span>
                <span style="font-size:11px;cursor:pointer;color:#666" @click="click_show_all_shareholders_false()" v-if="show_all_shareholders==true">(Hide Inactive Shareholders)</span>

          </div>
          <div v-if="noShareholders" style="color: #999;padding: 10px;font-size: 12px;"> - No shareholders found - </div>
           <div v-for="shareholder in coy.shareholders" >

          	<div v-if="shareholder.person && (shareholder.num_shares>0 || show_all_shareholders == true)">
				<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="shareholder.id" :value="shareholder.id"
				 v-model="selectedShareholders['s'+shareholder.id]"
				 :disabled="!shareholder.person.email"
				 >
					<span style="font-weight:normal">
						<span style="color:#000;">{{shareholder.person.first_name}} {{shareholder.person.last_name}} </span>
						- {{shareholder.person.gov_id}} - 
						({{shareholder.num_shares}} 
						 <span v-if="shareholder.pivot.share_type==1">Ordinary</span>
						 <span v-if="shareholder.pivot.share_type==2">Preference</span>
						<span v-for="st in coy.share_types">
						  <span v-if="shareholder.pivot.share_type==st.id">{{st.name}}</span>
					  </span>
					   Shares)
					  <span v-if="shareholder.person.email" style="color:#000">- {{shareholder.person.email}}</span>
					</span>
				</p-checkbox>
          	</div>

          	<div  v-if="shareholder.shareholder_company && (shareholder.num_shares>0 || show_all_shareholders == true)">
          	<p-checkbox  style="margin-bottom:15px;margin-top:15px;" :id="shareholder.id" :value="shareholder.id"
          	 v-model="selectedShareholders['s'+shareholder.id]"
          	 :disabled="!shareholder.shareholder_company.person.email"
          	 >
          	  		<span v-if="shareholder.is_company==1">{{shareholder.shareholder_company.company_name}} - </span>
          	  		({{shareholder.num_shares}}
          			 <span v-if="shareholder.pivot.share_type==1">Ordinary</span>
  	 				 <span v-if="shareholder.pivot.share_type==2">Preference</span>
          			<span v-for="st in coy.share_types">
				  	  <span v-if="shareholder.pivot.share_type==st.id">{{st.name}}</span>
				  </span>
				   Shares)
					  (Representative:
          			<span style="color:#000">{{shareholder.shareholder_company.person.first_name}} {{shareholder.shareholder_company.person.last_name}}  </span>
          			<span v-if="shareholder.shareholder_company.person.email" style="color:#000">- {{shareholder.shareholder_company.person.email}}</span>
          			)

          	</p-checkbox>
          	</div>
        
          </div>
          </div> <!-- end shareholders signers -->
          
          <div v-if="coy.company_type==7" stye="margin-bottom:50px;">
          <div style='margin-top:50px;'> <h5 class="title">Members</h5></div>
          <div v-if="noMembers" style="color: #999;padding: 10px;font-size: 12px;"> - No members found - </div>
           <div v-for="member in coy.members" >

          	<div v-if="member.person">
          	<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="member.id" :value="member.id"
          	 v-model="selectedMembers['m'+member.id]"
          	 :disabled="!member.person.email"
          	 >
          	 	<span style="font-weight:normal">
          			<span style="color:#000;">{{member.person.first_name}} {{member.person.last_name}} </span>

				  <span v-if="member.person.email" style="color:#000">- {{member.person.email}}</span>
          		</span>
          	</p-checkbox>
          	</div>

          	<div  v-if="member.shareholder_company">
          	<p-checkbox  style="margin-bottom:15px;margin-top:15px;" :id="member.id" :value="member.id"
          	 v-model="selectedMembers['m'+member.id]"
          	 :disabled="!member.shareholder_company.person.email"
          	 >
          	  		<span v-if="member.is_company==1">{{member.shareholder_company.company_name}} - </span>
          	  	
					  (Representative:
          			<span style="color:#000">{{member.shareholder_company.person.first_name}} {{member.shareholder_company.person.last_name}}  </span>
          			<span v-if="member.shareholder_company.person.email" style="color:#000">- {{member.shareholder_company.person.email}}</span>
          			)

          	</p-checkbox>
          	</div>
        
          </div>
          </div><!-- -End members signers -->



     

       </card>
       
       <card>
       	  <!-- start: add additional signers -->
       <div style="">
       		<h5 class="title">Add Additional Signer(s)</h5>

      	 	<div>
       			  <div v-for="(as, index) in additionalSigners" style="font-weight:bold;">
       			  {{index+1}})	{{as.first_name}} {{as.last_name}} ({{as.gov_id}}) - {{as.email}}
       			   <span style="color:red;cursor:pointer;" @click="removeAdditionalSigner(as.id, as.task_id, index)" > [Delete]</span>
       			  </div>
       		</div>


       		 <div v-if="" style="text-align:left; margin-top:50px;">

			  <div>Add New Signer Using Govt ID/Passport Number</div>
				   <fg-input type="text"
                  		name="search_signer_id_num"
                 	    v-model="search_signer_id_num"
                 	    style="max-width:500px"
                 	    >
        			</fg-input>


			   <p-button  type="info" @click.prevent="searchPerson('signer')">Search People</p-button>
			   </div>
       </div>

       <!-- end: add additional signers-->
       
       </card>
 <!-- end: who should sign -->



<div style="margin-top:80px;">
   <h4 class="title">Generate The Document (Optional)</h4>
 </div>



<card>
<div style="">


 <p-button v-if="!sentForSigning && displayGeneratePdfButton==true" @click="validateGenerateResolutionPdf()" native-type="submit"  type="warning" >Generate New Document PDF</p-button>
 <p-button v-if="pdf_path" @click="viewPdf()" type="success">Preview New Document</p-button>

          <p-button  v-if="main_document.id"  @click="viewDocumentPdf(0)" type="default">View Original Document</p-button>

</div>



</card>

 <div style="margin-top:80px;">
   <h4 class="title">Save This Task</h4>
 </div>

<card>
	<div v-if="!sentForSigning" style="text-align:center;">
           		<p-button   round  @click="validateSaveTask_init()" type="default">Save Task & Document</p-button>
	</div>
	<div v-if="sentForSigning" style="margin-top:10px; margin-bottom:10px;">
		<strong> * No edits allowed after resolution has been sent for signing. Please delete the corresponding task and create a new resolution.</strong>
	</div>
</card>

<!-- footer spacing -->
<div style="width:100%;height:350px;"></div>

  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
	
 
	
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {
     
     	 this.reso_options.docu_date = new Date();
     	 this.taskid = this.$route.params.tid;
      	 this.loadResolutionBuilder();
    },
    data () {
      return {
        main_document: {
        	signing_log_file_name: "",
        	signed_document_file_name:""

        },
        pdf_path: '',
        taskid: 0,
        errorBags: '',
        displayRType: 1,
        signing_status:'Not Available',
        sentForSigning: false,
        displaySelectShareCert: false,
        selectedOfficersArr:[],
        selectedOfficers: [],
        selectedShareholdersArr:[],
        selectedShareholders: [],
        selectedMembersArr:[],
        selectedMembers: [],
        additionalSigners:[],
        noShareholders: true,
        noMembers: true,
        noOfficers: true,
        showTransferFrom: false,
      	displayOfficerSearch: false,
      	displayMemberSearch: false,
      	displayShareholderSearch: false,
      	displayShareholderSelect: false,
      	displayCancelShareCertSelect: false,
      	displayIssueShareCertSelect: false,
      	displayGeneratePdfButton: true,
      	search_officer_id_num:'',
      	search_shareholder_id_num:'',
      	search_shareholder_company_reg_num:'',
      	search_member_id_num:'',
      	search_member_company_reg_num:'',
      	search_signer_id_num:'',
      	people_qsearch:'',
      	qsearch_result:[],
      	qsearch_result_init: 0,
      	share_cert: '',
      	share_cert_saved: '',
      	generic_person1_found: false,
      	generic_company_found: false,
      	member1_found: false,
      	officer1_found: false,
      	officer2_found: false,
      	m_coy_found: false,
      	sh_coy_found:false,
      	sh1_found: false,
      	sh2_found: false,
      	show_all_shareholders: false,
      	show_all_officers: false,
      	displayPaidUpCap: true,
      	displaySavedHeader: false,
      	search_generic_person_id_num:"",
      	search_generic_company_id_num:"",
      	new_reso_item: "",
      	new_reso_items: [],
      	new_reso_items_saved: [],
      	officer_changes: [],
      	officer_changes_saved:[],
      	member_changes:[],
      	member_changes_saved:[],
      	member_company_changes:[],
      	member_company_changes_saved:[],
      	shareholder_changes:[],
      	shareholder_changes_saved:[],
      	shareholder_company_changes:[],
      	shareholder_company_changes_saved:[],
      	cancel_share_certs:[],
      	cancel_share_cert_init:'',
      	cancel_share_certs_saved: [],
      	issue_share_certs:[],
      	issue_share_certs_saved: [],
      	issue_share_cert_init:[],
      	show_share_transfer_form: false,
      	showCloseBankAccountForm: false,
      	showOpenBankAccountForm: false,
      	closeBankAccount:{
      		name:'',
      		acNumber:'',
      	},
      	displayCancelShareCertForm: false,
      	displayAddCustomItemForm: false,
      	displayAddCustomItemNew: false,
      	displayIssueShareCertForm: false,
      	displaySigning: false,
      	displayPreviewShareCert: false,
      	displayPreview: false,
      	displayPreviewOfficer1: false,
      	displayPreviewOfficer2: false,
      	displayPreviewSh1: false,
      	displayPreviewSh2: false,
      	m_coy:{
      		pid:'',
      		sh_coy_id:'',
      		is_company: 1,          
        	effective_date:'',
        	company_info:'',
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}
      	},
      	sh_coy:{
      		pid:'',
      		sh_coy_id:'',
      		is_company: 1,
          	share_type: 1,
        	num_shares: '',
        	transaction_type:1,
        	paid_up_capital: '',
        	currency:'SGD',
        	effective_date:'',
        	transfer_tofrom_id:'',
        	company_info:'',
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}
      	},
      	generic_person1:{
      		pid:'',
      		sh_coy_id:'',
      		is_company: 2,     
        	effective_date:'',
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}      	
      	},
      	member1:{
      		pid:'',
      		sh_coy_id:'',
      		is_company: 2,     
        	effective_date:'',
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}
      	},
      	sh1:{
      		pid:'',
      		sh_coy_id:'',
      		is_company: 2,
          	share_type: 1,
        	num_shares: '',
        	transaction_type:1,
        	paid_up_capital: '',
        	currency:'SGD',
        	effective_date:'',
        	transfer_tofrom_id:'',
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}
      	},

      	officer1:{
      		pid:'',
      		status: 1,
          	effective_date: '',
          	position:1,
          	title:"Director",
          	isContactPerson: 2,
          	person:{
          		  first_name: '',
				  last_name: '',
				  address_1: '',
				  gov_id:'',
				  contact_num:'',
          	}
      	},

      	reso_options:{
      		header: 1,
      		docu_date: '',
      		sub_header:'',
      		agm_audited: 2,
      		meeting_type:"AGM",
      		agenda_general: true,
      	},
		resolutions: {
			ch_coy_name:false,
			ch_coy_address:false,
			ch_coy_activity:false,
			ch_coy_fye:false,

		},
        coy:{

        },
        coyInfoChange:[],
        coyInfoChangeSaved:[],
        coyInfo:{
        	address: '',
        	name:'',
        	fye:'',
        	activity1:'',
        	activity2:'',
        	effective_date:'',
        },
        coyInfoAddress:{
        	effective_date:'',
        },
        sharesValidations:{
          share_type: {
            required: true
          },
          num_shares: {
            required: true,
          },

        },
         modelValidations: {
          docu_date: {
            required: true
          },
          officer_title: {
            required: true,
          },
          reso_header: {
            required: true,
          },
          date_incorp: {
          	required: true,
          },
          company_type: {
            required: true,
          },
          company_status: {
            required: true,
          },
          registered_address:{
          	required: true,
          }
        },
		 getErrorCs(fieldName, scope) {
        	return this.errors.first(fieldName, scope)
      	},
         getError(fieldName) {
        	return this.errors.first(fieldName)
      	},
        shareholders_list_full: [], //shareholder detailed
        share_certs_list_full: [],
        selects: {
          officer_status: [
            {value: 1, label: 'Appointed'},
            {value: 2, label: 'Resigned'},
		   ],
		   officer_position: [
            {value: 1, label: 'Director'},
            {value: 2, label: 'Nominee Director'},
            {value: 3, label: 'Secretary'},
            {value: 4, label: 'Director & Secretary'},
            {value: 5, label: 'Data Protection Officer'},
            {value: 6, label: 'Director & Data Protection Officer'},
		   ],
		   share_type: [
            {value: 1, label: 'Ordinary'},
            {value: 2, label: 'Preference'},
		   ],
		   shareholders_list: [], //only "distinct" shareholders

		  transaction_type:[
            {value: 1, label: 'Allotment Of New Shares'},
            {value: 3, label: 'Transfer From Another Shareholder To This Shareholder'},
		   ] ,
		   yesno:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] ,
		   meeting_type:[
            {value: "AGM", label: 'AGM'},
            {value: "EGM", label: 'EGM'},
		   ] ,
		   
		    currencies:[
            {value: "SGD", label: 'SGD'},
            {value: "CNY", label: 'CNY'},
            {value: "EUR", label: 'EUR'},
            {value: "JPY", label: 'JPY'},
            {value: "MYR", label: 'MYR'},
            {value: "USD", label: 'USD'},
           
		   ] ,
		   reso_headers:[
		   	  {value: 1, label: 'Directors\' Resolution'},
              {value: 2, label: 'EGM (Minutes & Resolution)'},
              {value: 3, label: 'AGM (Minutes & Resolution)'},
             // {value: 4, label: 'EGM (Minutes & Resolution)'},
              {value: 13, label: 'Directors\' Declaration For AGM'},
              {value: 5, label: 'Notice For AGM/EGM'},
              {value: 8, label: 'Consent To Short Notice For AGM/EGM'},
              {value: 6, label: 'Share Certificate'},
              {value: 9, label: 'Share Transfer'},
              {value: 11, label: 'Nominee Director Agreement'},
              {value: 12, label: 'Appointment Of Company Secretary'},
              {value: 14, label: 'Certificate Of Appointment Of Representative'},
              {value: 7, label: 'Company Incorporation'},
              {value: 10, label: 'Company Setup - Internal'},
              {value: 17, label: 'Form 45'},
              {value: 18, label: 'Form 45B'},
              {value: 15, label: 'Striking-off (Balance Sheet 0|0)'},
              {value: 16, label: 'Resignation As Secretary/Director/etc'},
              
              
              //latest value is 18:  form 45B
            
		   ]
        },//end selects
      }
    },
    methods:{
        click_show_all_shareholders(){
        	this.show_all_shareholders = true;
        },
        click_show_all_shareholders_false(){
        	this.show_all_shareholders = false;
        },
        click_show_all_officers(){
        	this.show_all_officers = true;
        },
        click_show_all_officers_false(){
        	this.show_all_officers = false;
        },
        
        
    	selectTaskType(type){
    		this.reso_options.header = type;
    		this.onResoDocTypeChange();
    		
    	},
    	addCloseBankAccount(){
    		this.showCloseBankAccountForm = true;


    	},
    	hideCloseBankAccount(){
    		this.showCloseBankAccountForm = false;
    	},
    	
    	
    	addOpenBankAccount(){
    		this.showOpenBankAccountForm = true;


    	},
    	hideOpenBankAccount(){
    		this.showOpenBankAccountForm = false;
    	},
    	
    	hideQsearchResults(){
    		this.qsearch_result_init = 0;
    	},
    	
    	onMeetingTypeChange(){
    		if(this.reso_options.meeting_type == "AGM" ){
    			this.reso_options.agenda_general = true;    		
    		}
    		else{
    			this.reso_options.agenda_general = false;
    		}
    	
    	
    	},
    	onResoDocTypeChange(){
    		if(this.reso_options.header == 6){
    			this.displayRType = 2;
    			this.includeReso('create_sc');
    			if(this.share_cert_saved){
    				this.displaySelectShareCert = false;
    			}
    			else{
    				this.displaySelectShareCert = true;
    			}
    			
    		}
    		else if(this.reso_options.header == 3){
    			this.displayRType = 3;
    		}
    		else if(this.reso_options.header == 9){
    			this.displayRType = 9;
    			this.sh1.transaction_type = 3;
    			this.sh_coy.transaction_type = 3;
    			this.transactionTypeChange();
    		}
    		else{
    			this.displayRType = 1;
    			this.removeNewShareCert();
    		}
   		},
   		addCloseBankAccountItem(){
   			let t = "the company’s bank account with "+this.closeBankAccount.name+" (Account Number: "+ this.closeBankAccount.acNumber+") be closed with immediate effect; and";

    		this.reso_options.sub_header = "Closure Of Bank Account"
    		this.new_reso_items.push(t);
    		this.displayAddCustomItemNew = true;
    		this.showCloseBankAccountForm = false;
   		},
   		addOpenBankAccountItem(){
   			let t = "The directors are authorized to open a bank account with "+this.reso_options.open_bank_name + " for the company with the following services, if available: <br/>- Savings Account <br/>- Internet Banking <br/>- Mobile Banking";
   			this.new_reso_items.push(t);
   			
   			
   			let p = this.reso_options.open_bank_authorized + " is/are authorized to operate the bank account as authorized signatories;";
   			this.new_reso_items.push(p);
   				
   				

    		this.reso_options.sub_header = "Opening Of Company Bank Account"
    		
    		
    		
    		//reso_options.open_bank_authorized
    		
    		
    		
    		
    		
    		
    		this.displayAddCustomItemNew = true;
    		this.showOpenBankAccountForm = false;
   		},
   		
    	addNewResoItem(){
    		this.new_reso_items.push(this.new_reso_item);
    		this.displayAddCustomItemNew = true;
    		
    		this.displayAddCustomItemForm = false;
    		this.new_reso_item = "";
    	},
    	removeNewResoItem(index){
    		this.new_reso_items.splice(index, 1);
    	},
    	addCustomResoItem(){
    		this.displayAddCustomItemForm = true;
    	},
    	hideCustomResoItem(){
    		this.displayAddCustomItemForm = false;
    	
    	},
    	add_share_transfer(){   	

    		swal.showLoading();
    		this.sh1.transaction_type = 3;
    		this.sh_coy.transaction_type = 3;
    		this.transactionTypeChange();
    		this.show_share_transfer_form =  true;
    		
    		swal.close();
    			
    	},
    	addCoyInfoChange(type){
    		if(type == "ch_address"){
    			this.resolutions.ch_coy_address = false;
    			let cic = {
    				"ch_type": 'ch_address',
    				"address": this.coyInfo.address,
    				"effective_date": this.coyInfoAddress.effective_date
    			}

    			this.coyInfoChange.push(cic);
    			this.coyInfo.address = '';
    		}
    		else if(type == "ch_coy_name"){
    			this.resolutions.ch_coy_name = false;
    			let cic = {
    				"ch_type": 'ch_coy_name',
    				"coy_name": this.coyInfo.coy_name,
    			}

    			this.coyInfoChange.push(cic);
    			this.coyInfo.coy_name = '';
    		}
    		else if(type == "ch_coy_fye"){
    			this.resolutions.ch_coy_fye = false;
    			let cic = {
    				"ch_type": 'ch_coy_fye',
    				"coy_fye": this.coyInfo.fye,
    			}

    			this.coyInfoChange.push(cic);
    			this.coyInfo.fye = '';
    		}
    		else if(type == "ch_coy_activity"){
    			
    			
    			var show_err = 0;
    			
    			if(this.coyInfo.principal_activity_1_code || this.coyInfo.principal_activity_1_title ||
    			this.coyInfo.principal_activity_1_desc){
    			
    				if(!this.coyInfo.principal_activity_1_code || !this.coyInfo.principal_activity_1_title ||
    					!this.coyInfo.principal_activity_1_desc){
    					
    							show_err = 1;		
    					}
    			}
    			
    			
    			if(this.coyInfo.principal_activity_2_code || this.coyInfo.principal_activity_2_title ||
    			this.coyInfo.principal_activity_2_desc){
    			
    				if(!this.coyInfo.principal_activity_2_code || !this.coyInfo.principal_activity_2_title ||
    					!this.coyInfo.principal_activity_2_desc){
    					
    							show_err = 1;		
    					}
    			}
    			
    			if(!this.coyInfo.principal_activity_1_code && !this.coyInfo.principal_activity_1_title &&
    					!this.coyInfo.principal_activity_1_desc
    					&&
    			!this.coyInfo.principal_activity_2_code && !this.coyInfo.principal_activity_2_title &&
    					!this.coyInfo.principal_activity_2_desc){
    					
    					show_err = 1;	
    			}
    			
    			
    			
    			if(show_err == 1){
    				swal({
					  title: 'Error!',
					  text: 'Please fill in the code, title and description of the principal activity',
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
    			
    			}
    			else{
					this.resolutions.ch_coy_activity = false;
					let cic = {
						"ch_type": 'ch_coy_activity',
						"coy_pa1_code": this.coyInfo.principal_activity_1_code,
						"coy_pa1_title": this.coyInfo.principal_activity_1_title,
						"coy_pa1_desc": this.coyInfo.principal_activity_1_desc,
						"coy_pa2_code": this.coyInfo.principal_activity_2_code,
						"coy_pa2_title": this.coyInfo.principal_activity_2_title,
						"coy_pa2_desc": this.coyInfo.principal_activity_2_desc,
					
					}

					this.coyInfoChange.push(cic);
    			}
    		}
    		else if(type == "ch_strike_off"){
    			let cic = {
    				"ch_type": 'ch_strike_off',
    				"strike_off": 1,
    			}
    			//this.reso_options.sub_header = "Striking-Off Of Company"
    			this.coyInfoChange.push(cic);
    		}
    	},
    	removeNewShareCert(){
    		this.share_cert = '';
    	},
    	removeAdditionalSigner(pid, tid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/tasks/delete_as/'+pid+"/"+tid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted',
					  text: 'The additional signer has been removed.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.additionalSigners.splice(index, 1);
					})
					//end swal
				})


			  })//end swal

    	},
    	removeSavedNewResoItem(criid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/tasks/delete_cri/'+ criid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'The custom resolution item has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.new_reso_items_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal

    	},
    	removeSavedCancelShareCert(cscid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/shareholders/delete_scc/'+ cscid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Cancel Share Certificate has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.cancel_share_certs_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal
    	},
    	removeSavedIssueShareCert(iscid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/shareholders/delete_scc/'+ iscid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Issue Share Certificate has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.issue_share_certs_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal

    	},
    	removeSavedOc(ocid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/officers/delete_oc/'+ ocid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Officer has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.officer_changes_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal


    	},
    	removeSavedMc(mcid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/officers/delete_mc/'+ mcid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Member has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.member_changes_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal


    	},
    	removeSavedMemberCompany(mcid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/officers/delete_mc/'+ mcid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Member has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.member_company_changes_saved.splice(index, 1);
					})
					//end swal
				})


			  })//end swal


    	},
    	removeSavedSh(stid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/shareholders/delete_st/'+ stid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Shares has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.shareholder_changes_saved.splice(index, 1);
					})
					//end swal
				})


			  })


    	},
    	removeSavedShCoy(stid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/shareholders/delete_st/'+ stid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change: Shares has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.shareholder_company_changes_saved.splice(index, 1);
					})
					//end swal
				})


			  })


    	},
    	removeSavedCoyInfoChange(cicid, index){
    		const vm = this;

			swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
			  }).then(function () {
					const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/entities/delete_cic/'+ cicid;

				 ApiService.get(uri).then(response => {
					swal({
					  title: 'Deleted!',
					  text: 'This Change has been deleted.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
							vm_.coyInfoChangeSaved.splice(index, 1);
					})
					//end swal
				})


			  })

    	},
    	addShareCert(index){
    		swal({
					  title: 'Done.',
					  text: 'Shareholder has been selected.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					})
					
    		this.share_cert = this.shareholders_list_full[index];
    	},
    	removeCoyInfoChange(index){
    		this.coyInfoChange.splice(index, 1);
    	},
    	validateAddOfficer(){
    		this.$validator.validateAll('addOfficer').then(isValid => {
        	  
        	  		if (!isValid) {
        	  			this.displayFieldErrorMessage();
        	  		
        	  		}else{
        	  			this.addOfficer();
        	  		}
        	  
        	  });
    	
    	},
    	addOfficer(){
    		let t = JSON.parse(JSON.stringify(this.officer1));
    		this.officer_changes.push(t);

    		this.officer1.pid = '';
    		this.officer1_found = false;
    	},
    	removeNewOfficerChange(index){
    		this.officer_changes.splice(index, 1);
    	},
    	removeNewMemberChange(index){
    		this.member_changes.splice(index, 1);
    	},
    	removeNewMemberCompanyChange(index){
    		this.member_company_changes.splice(index, 1);
    	},
    	removeNewMemberCompanyChange(index){
    		this.member_company_changes.splice(index, 1);
    	},
    	removeNewShareholderChange(index){
    		this.shareholder_changes.splice(index, 1);
    	},
    	removeNewShareholderCompanyChange(index){
    		this.shareholder_company_changes.splice(index, 1);
    	},
    	removeCancelShareCert(index){
    		this.cancel_share_certs.splice(index, 1);
    	},
    	removeIssueShareCert(index){
    		this.issue_share_certs.splice(index, 1);
    	},
    	addShareholderCompany(){
    		let t = JSON.parse(JSON.stringify(this.sh_coy));
    		this.shareholder_company_changes.push(t);

    		this.sh_coy_found = false;

    	},
    	
    	validateAddMember(){
    		this.$validator.validateAll('addMember').then(isValid => {
			  
						if (!isValid) {
							this.displayFieldErrorMessage();
						}else{
							this.addMember();
						}
			  
				  });
    	
    	},
    	validateAddMemberCompany(){
    		this.$validator.validateAll('addMemberCompany').then(isValid => {
			  
						if (!isValid) {
							this.displayFieldErrorMessage();
						}else{
					
							this.addMemberCompany();
						}
			  
				  });
    	
    	},
    	validateAddShareholder(type){
    		let v = false;
    		
    		var shareholder = null;
    		if(type == 'i'){
    			shareholder =this.sh1;
    		}
    		else if(type == 'c'){
    			shareholder =this.sh_coy;
    		}
    		
    		
    		if(shareholder.transaction_type == 1){
    			if(shareholder.paid_up_capital && shareholder.currency){
    				v = true;
    			}
    			else{
    				swal({
					  title: 'Error!',
					  text: 'Please fill in the paid-up capital and currency',
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
    			
    			}

    		}
    		else if(shareholder.transaction_type == 3){
    			if(shareholder.transfer_tofrom_id){
    				v = true;
    			
    			}else{
    				swal({
					  title: 'Error!',
					  text: 'Please select which shareholder is transferring the shares',
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
    			
    			}
    		
    		
    		}
    	
    		if(v == true && type == 'i'){
				this.$validator.validateAll('addShareT').then(isValid => {
			  
						if (!isValid) {
							this.displayFieldErrorMessage();
						}else{
							this.addShareholder();
						}
			  
				  });
    		}
    		else if(v == true && type == 'c'){
				this.$validator.validateAll('addShareTCoy').then(isValid => {
			  
						if (!isValid) {
							this.displayFieldErrorMessage();
						}else{
							this.addShareholderCompany();
						}
			  
				  });
    		}
    	
    	},
    	addShareholder(){
    		let t = JSON.parse(JSON.stringify(this.sh1));
    		this.shareholder_changes.push(t);

    		this.sh1.pid = '';
    		this.sh1_found = false;
    	},
    	addMember(){
    		let t = JSON.parse(JSON.stringify(this.member1));
    		this.member_changes.push(t);

    		this.member1.pid = '';
    		this.member1_found = false;
    	},
    	addMemberCompany(){
    		let t = JSON.parse(JSON.stringify(this.m_coy));
    		this.member_company_changes.push(t);

    		this.m_coy.pid = '';
    		this.m_coy_found = false;
    	},
    	initIssueShareCert(index){
    		let t = JSON.parse(JSON.stringify(this.share_certs_list_full[index]));
    		this.issue_share_cert_init = t;
    		this.displayIssueShareCertForm = true;

    	},
    	issueShareCert(index){
    		let t = this.issue_share_cert_init;
    		this.issue_share_certs.push(t);
    		this.displayIssueShareCertForm = false;
    		this.issue_share_cert_init = '';

    	},

    	initCancelShareCert(index){
    		let t = JSON.parse(JSON.stringify(this.share_certs_list_full[index]));
    		this.cancel_share_cert_init = t;
    		this.displayCancelShareCertForm = true;
    	},

    	cancelShareCert(index){
    		let t = this.cancel_share_cert_init;
    		this.cancel_share_certs.push(t);
    		this.displayCancelShareCertForm = false;
    		this.cancel_share_cert_init = '';

    	},
    	onTransactionTypeChange(event){
       		
			this.transactionTypeChange();
       },
       transactionTypeChange(){
       	  if(this.sh1.transaction_type == 3 || this.sh_coy.transaction_type == 3){
       			this.displayPaidUpCap = false;
       			let uri = this.$base_url+'/api/v1/shareholders/entity/'+this.$route.params.eid;

      			ApiService.get(uri).then(response => {

      				this.selects.shareholders_list = response.data.shareholders;
      				this.showTransferFrom = true;


      			});

       		}else{
       			this.displayPaidUpCap = true;
       			this.showTransferFrom = false;
       		}
       
       },
	   infoCompanySetup(){
			
			swal({
					  title: 'Tip',
					  text: 'Select this option if you wish to make changes to a company\'s structure including directors and shareholding which are not filed with ACRA.',
					  type: 'info',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
		
	   },
	   infoform45(){
			
			swal({
					  title: 'Tip',
					  text: 'Simply select the director(s) who should sign the Form 45 below.',
					  type: 'info',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
		
	   },
	   infoform45b(){
			
			swal({
					  title: 'Tip',
					  text: 'Simply select the secretary who should sign the Form 45B below.',
					  type: 'info',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
		
	   },
       loadTaskInfo(){
       		if(this.taskid != 0){
				 this.displaySigning = true;
				 this.displayPreview = true;

				 this.officer1_found = false;
				 this.officer2_found = false;
				 this.sh1_found = false;
				 this.sh2_found = false;



				 let uri = this.$base_url+'/api/v1/tasks/get_custom_reso/'+ this.taskid;
				 ApiService.get(uri).then(response => {

						const vm = this;
						if(response.data.main_document){
							this.main_document =  response.data.main_document;
							//this.main_document.id =  response.data.task.main_document;


							if(this.main_document.signing_status != null){
								this.main_document = response.data.main_document;

								this.updateSigningStatus(this.main_document.signing_status);
								this.sentForSigning =  true; //no edits allowed after sent for signing
							}
						}

						let count = 0;

						if(response.data.ocs_saved){
						 	this.officer_changes_saved = response.data.ocs_saved;
						 	count = count + response.data.ocs_saved.length;
						}

						if(response.data.shs_saved){
						 	this.shareholder_changes_saved = response.data.shs_saved;
						 	count = count + response.data.shs_saved.length;
						}
						if(response.data.mc_saved){
						 	this.member_changes_saved = response.data.mc_saved;
						 	count = count + response.data.mc_saved.length;
						}
						
						if(response.data.member_company_changes_saved){
						 	this.member_company_changes_saved = response.data.member_company_changes_saved;
						 	count = count + response.data.member_company_changes_saved.length;
						}
						
						
						
						
						if(response.data.share_cert_saved){
							this.share_cert_saved = response.data.share_cert_saved;
							this.displayPreviewShareCert = true;
							count = count + response.data.share_cert_saved.length;

						}

						if(response.data.cancel_share_certs_saved){
							this.cancel_share_certs_saved = response.data.cancel_share_certs_saved;
							count = count + response.data.cancel_share_certs_saved.length;
						}
						if(response.data.issue_share_certs_saved){
							this.issue_share_certs_saved = response.data.issue_share_certs_saved;
							count = count + response.data.issue_share_certs_saved.length;
						}

						if(response.data.coy_info_changes_saved){
							this.coyInfoChangeSaved = response.data.coy_info_changes_saved;
							count = count + response.data.coy_info_changes_saved.length;
						}

						if(response.data.new_reso_items_saved){
							this.new_reso_items_saved = response.data.new_reso_items_saved;
							count = count + response.data.new_reso_items_saved.length;
						}

						if(response.data.shareholder_company_changes_saved){

							this.shareholder_company_changes_saved = response.data.shareholder_company_changes_saved;
							count = count + response.data.shareholder_company_changes_saved.length;
						}
						
					
						
						
						if(count>0){
							this.displaySavedHeader = true;
						}

						if(response.data.additional_signers){

							this.additionalSigners = response.data.additional_signers;
						}


						if(response.data.reso_options){
							let ro = response.data.reso_options;
							//if no reso options exist

							if(!response.data.reso_options.docu_date){
								response.data.reso_options.docu_date = new Date();
							}
							if(!response.data.reso_options.header){
								if(response.data.task.task_type==1){
									response.data.reso_options.header = 3;
								}
								else{
									response.data.reso_options.header = 1;
								}
							}//end if
							
							this.reso_options = ro;

						}
						
						//share cert.
						if(this.reso_options.header == 6){
							
							this.displayGeneratePdfButton = false;
						}
						
						


						//process signers
						response.data.saved_signers.forEach(function(signer){
							if(signer.type==1){
								vm.selectedOfficers["o"+signer.officer_id] = true;

							}
							else if(signer.type==2){

								vm.selectedShareholders["s"+signer.shareholder_id] = true;
							}
							else if(signer.type==4){

								vm.selectedMembers["m"+signer.member_id] = true;
							}
						});

						this.onResoDocTypeChange();
						swal.close();

				})//end response
			}//end if task exists
       		else{

       			swal.close();
       		}

       },

		loadResolutionBuilder(){
			swal.showLoading();

			let uri = this.$base_url+'/api/v1/entities/simple_details/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
						this.coy = response.data.entity;
						let vm = this;


						//for signing
						response.data.entity.officers.forEach(function(officer){
						   vm.noOfficers = false;
						
							vm.selectedOfficers["o"+officer.id] = false;
						});

						//for signing
						response.data.entity.shareholders.forEach(function(shareholder){
							vm.noShareholders = false;
							
							if(shareholder){
								vm.selectedShareholders["s"+shareholder.id] = false;
							}
						});
						
						response.data.entity.members.forEach(function(member){
							vm.noMembers = false;
							
							if(member){
								vm.selectedMembers["m"+member.id] = false;
							}
						});

						response.data.entity.share_types.forEach(function(st){
							let stype = {
								"value": st.id,
								"label": st.name,
							}

						   vm.selects.share_type.push(stype);
						});

					  this.loadTaskInfo();

			})
		},//end resolutionBuilder
        viewDocumentPdf(type){
    		this.$router.push( '/view-document/'+this.main_document.id+"/"+type);
    	},
        sendForSigning(){
    		let uri = this.$base_url+'/api/v1/documents/send_signing';
      		ApiService.post(uri, {
    			"pdf_path":this.pdf_path,
    			"tid": this.taskid,
    		}).then(response => {

         			//alert("document generated at: "+response)
         			this.sentStatus = 1;
         			this.signing_status = "Document sent to signee for signing";
         			this.saveTask();




     		 })

    	},
    	qsearchPerson_onkey(event){
    		let uri = this.$base_url+'/api/v1/entities/search/quick';
    		this.$nextTick(() => {
				if (this.people_qsearch.length > 1) {
				 	ApiService.post(uri, {
					"eid": this.$route.params.eid,
					"query": this.people_qsearch,
					}).then(response => {
							this.qsearch_result = response.data.people
							this.qsearch_result_init = 1;
					})
				}
			  });
    	
    	
    	},
    	qsearchPerson(){
    			swal.showLoading();
    			let uri = this.$base_url+'/api/v1/entities/search/quick';
				ApiService.post(uri, {
					"eid": this.$route.params.eid,
					"query": this.people_qsearch,
				}).then(response => {
						this.qsearch_result = response.data.people
						this.qsearch_result_init = 1;
						swal.close();
				})

    	
    	
    	
    	},
    	refreshStatus(){
    		//start testing
    	    const vm = this;
			let uri2 = this.$base_url+'/api/v1/documents/refresh';
				ApiService.post(uri2, {
					"tid":this.taskid
				}).then(response => {
							vm.main_document = response.data.document;
							this.updateSigningStatus(vm.main_document.signing_status);

			})

			//end testing

    	},
       goToChange(ch){
       		if(ch == "sh1"){
       			 this.$router.push( '/create-share-transaction/'+this.sh1.stid+'/entity/'+this.$route.params.eid+"/edit");
       		}
       		else if(ch == "sh2"){
       			 this.$router.push( '/create-share-transaction/'+this.sh2.stid+'/entity/'+this.$route.params.eid+"/edit");
       		}
       		else if(ch == "officer1"){
       			 this.$router.push( '/create-officer-change/'+this.officer1.ocid+'/entity/'+this.$route.params.eid+"/edit");
       		}



       },
       updateSigningStatus(status){
       		this.signing_status = "---";
       		if(status == "vi"){
				this.signing_status = "Viewed By Signers";
			}
			else if(status == "se"){
				this.signing_status = "Sent For Signing";
			}
			else if(status == "si"){
				this.signing_status = "Signing Complete";
			}
			else if(status == "co"){
				this.signing_status = "Processing Document For Signing";
			}
       },
       validateSaveTask_init(){
       		
       	    let v = false;
       		
       		if(this.reso_options.header==6){
       		
       			if(this.main_document.id || this.share_cert.cert_num){
       			
       				v = true;
       			}
       			else{
       				swal({
					  title: 'Error!',
					  text: 'Please generate the PDF for the share certificate before saving.',
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 		})
       			
       			}
       		}//end if
       		else{
       		
       			v = true;
       		}
       
       
       		if(v==true){
       			this.$validator.validateAll('document').then(isValid => {
        	  
        	  		if (!isValid) {
        	  			this.displayFieldErrorMessage();
        	  		
        	  		}else{
        	  			this.saveTask_init();
        	  		}
        	  
        	 	 });
       		}
       
       },
       saveTask_init(){
       		let msg = "Please make sure the details are correct.";

       		if(this.main_document.id && this.pdf_path){
       			msg = "The existing resolution PDF will be deleted and replaced by the new document PDF.";
       		}

       		if(this.main_document && this.main_document.signing_status != null){
       			//no edits allowed. document already sent for signing.
       		}
       		else{

       		const vm = this;
			swal({
					title: 'Are you sure?',
					text: msg,
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then(function () {
						vm.saveTask();
					}
					, function(dismiss) {
 						 if (dismiss === 'cancel'){
 						 }

 					  }
					)//end swal

			}//end if-else

       },
       saveTask(){

       		//get signers:
       		const vm = this;
       		vm.selectedOfficersArr = [];
			vm.selectedShareholdersArr = [];
			vm.selectedMembersArr = [];

			var off = this.coy.officers;
			off.forEach(function(t){
				if(vm.selectedOfficers["o"+t.id]==true){
					vm.selectedOfficersArr.push(t.id);
				}
			});


			var shs = this.coy.shareholders;
			shs.forEach(function(s){
				if(s && vm.selectedShareholders["s"+s.id]==true){
					vm.selectedShareholdersArr.push(s.id);
				}
			});
			
			
			
			var ms = this.coy.members;
			ms.forEach(function(m){
				if(m && vm.selectedMembers["m"+m.id]==true){
					vm.selectedMembersArr.push(m.id);
				}
			});



    		let uri = this.$base_url+'/api/v1/tasks/save_custom_resolution';

    		if(this.displayPreview == true && this.taskid){
    			 ApiService.post(uri, {
					 "pdf_path":this.pdf_path,
					 "reso_options":this.reso_options,
					 "entity_id": this.$route.params.eid,
					 "officers":this.selectedOfficersArr,
					 "tid": this.taskid,
					 "coy_info_changes": this.coyInfoChange,
					 "custom_reso_items": this.new_reso_items,
					 "ocs": this.officer_changes,
					 "shs": this.shareholder_changes,
					 "mc": this.member_changes,
					 "member_company_changes": this.member_company_changes,
					 "shareholder_company_changes": this.shareholder_company_changes,
					 "share_cert": this.share_cert,
					 "cancel_share_certs": this.cancel_share_certs,
					 "issue_share_certs": this.issue_share_certs,
					 "officers_signer":this.selectedOfficersArr,
    				 "shareholders_signer":this.selectedShareholdersArr,
    				  "members_signer":this.selectedMembersArr,
    				 "additional_signers": this.additionalSigners,
				}).then(response => {

						swal({
							  title: 'Done!',
							  text: "This task has been successfully saved.",
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						}).then(function(){

							vm.$router.push( '/edit-task/'+vm.$route.params.tid+'/entity/'+vm.$route.params.eid)
						})

				 })//end post


    		}
    		else{
				ApiService.post(uri, {
					 "pdf_path":this.pdf_path,
					  "resolutions":this.resolutions,
					 "reso_options":this.reso_options,
					 "coy_info_changes": this.coyInfoChange,
					  "custom_reso_items": this.new_reso_items,
					 "ocs": this.officer_changes,
					 "shs": this.shareholder_changes,
					 "mc": this.member_changes,
					 "shareholder_company_changes": this.shareholder_company_changes,
					 "cancel_share_certs": this.cancel_share_certs,
					 "issue_share_certs": this.issue_share_certs,
					 "share_cert": this.share_cert,
					 "coy":this.coy,
					 "entity_id": this.$route.params.eid,
					 "officers":this.selectedOfficersArr,
					 "officers_signer":this.selectedOfficersArr,
    			     "shareholders_signer":this.selectedShareholdersArr,
    			      "members_signer":this.selectedMembersArr,
    			     "additional_signers":this.additionalSigners,

				}).then(response => {
						let new_task_id = response.data.task_id;
						vm.taskid = response.data.task_id;
						swal({
							  title: 'Done!',
							  text: "This task has been successfully saved.",
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						}).then(function(){
							vm.$router.push( '/edit-task/'+new_task_id+'/entity/'+vm.$route.params.eid)

						})

				 })//end post
			 }

       },//end save task
       viewPdf(){
    		window.open(this.pdf_path, "_blank");
    	},
        validateGenerateResolutionPdf(){
        	  this.$validator.validateAll('document').then(isValid => {
        	  
        	  		if (!isValid) {
        	  			this.displayFieldErrorMessage();
        	  		
        	  		}else{
        	  			this.generateResolutionPdf();
        	  		}
        	  
        	  });
        },
        displayFieldErrorMessage(){
        		swal({
					  title: 'Error!',
					  text: 'Please check that all fields have been entered correctly.',
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	
       generateResolutionPdf(){
       	    //this.main_document = null;
    		swal.showLoading();
    		//get signers
			const vm = this;
			vm.selectedOfficersArr = [];
			vm.selectedShareholdersArr = [];
			vm.selectedMembersArr = [];

			var off = this.coy.officers;
			off.forEach(function(t){
				if(vm.selectedOfficers["o"+t.id]==true){
					vm.selectedOfficersArr.push(t.id);
				}
			});


			var shs = this.coy.shareholders;
			shs.forEach(function(s){
				if(s && vm.selectedShareholders["s"+s.id]==true){
					vm.selectedShareholdersArr.push(s.id);
				}
			});
			
			
			var ms = this.coy.members;
			ms.forEach(function(m){
				if(m && vm.selectedMembers["m"+m.id]==true){
					vm.selectedMembersArr.push(m.id);
				}
			});
			//end: get signers

    		let uri = this.$base_url+'/api/v1/documents/custom_resolution';
      		ApiService.post(uri, {
    			 "resolutions":this.resolutions,
    			 "reso_options":this.reso_options,
    			  "generic_person1":this.generic_person1,
    			 "coy":this.coy,
    			 "coy_info_changes": this.coyInfoChange,
    			 "coy_info_changes_saved":this.coyInfoChangeSaved,
    			 "ocs": this.officer_changes,
    			 "ocs_saved": this.officer_changes_saved,
    			 "shs": this.shareholder_changes,
    			 "shs_saved": this.shareholder_changes_saved,
    			 "mc": this.member_changes,
    			 "mc_saved": this.member_changes_saved,
    			 "shareholder_company_changes": this.shareholder_company_changes,
    			 "shareholder_company_changes_saved": this.shareholder_company_changes_saved,
    			 "share_cert": this.share_cert,
    			 "cancel_share_certs": this.cancel_share_certs,
    			 "cancel_share_certs_saved": this.cancel_share_certs_saved,
    			 "issue_share_certs": this.issue_share_certs,
    			 "issue_share_certs_saved": this.issue_share_certs_saved,
    			 "custom_reso_items": this.new_reso_items,
    			 "custom_reso_items_saved": this.new_reso_items_saved,
    			 "entity_id": this.$route.params.eid,
    			 "officers_signer":this.selectedOfficersArr,
    			 "shareholders_signer":this.selectedShareholdersArr,
    			 "members_signer":this.selectedMembersArr,
    			 "additional_signers":this.additionalSigners,
    			 "sh_coy": this.sh_coy,

    		}).then(response => {
      				swal.close();
      				swal({
						  title: 'Done!',
						  text: 'The document has been successfully generated. Remember to save the document too!',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
					})
         			//alert("Document generated at: "+response.data.document_path)
         			if(this.share_cert){
         				this.share_cert.cert_num = response.data.cert_num;
         			}

         			this.pdf_path = response.data.document_path;
     		 })
     		   .catch(error => {
        			 console.log(error)
       				 //this.errored = true
       				 swal({
						  title: 'Oops!',
						  text: 'Please check that all fields are filled in or refresh this page and try again.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
					})
       				 
     		 })
     		 
     		 
       },//end submitResolutionDetails
  		hideAddNewChangeOfficer(){
  			this.officer1_found = false;
  		},
  		hideAddNewChangeMember(){
  			this.member1_found = false;
  		},
  		hideAddNewChangeMemberCompany(){
  			this.m_coy_found = false;
  		},
  		hideAddNewChangeShareholder(){
  			this.sh1_found = false;
  		},
  		hideAddNewChangeShareholderCompany(){
  			this.sh_coy_found = false;
  		},
    	hideShareholderSearch(){
    		this.displayShareholderSearch = false;
    	},
    	hideShareholderSelect(){
    		this.displayShareholderSelect = false;
    	},
    	hideCancelShareCertSelect(){
    		this.displayCancelShareCertSelect = false;
    	},
    	hideIssueShareCertSelect(){
    		this.displayIssueShareCertSelect = false;
    	},
    	hideOfficerSearch(){
    		this.displayOfficerSearch = false;
    	},

    	searchShareholderCompany(){
    		let search_term = this.search_shareholder_company_reg_num;

    		let uri = this.$base_url+'/api/v1/shareholders/search_company/'+search_term;

       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){

     				     this.sh_coy.person = response.data.shareholder_company.person;
      					 this.sh_coy.company_info = response.data.shareholder_company;

      					 this.sh_coy_found = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Company not found. Please add this company to the "People" database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })
    	},
    	searchMemberCompany(){
    		let search_term = this.search_member_company_reg_num;

    		let uri = this.$base_url+'/api/v1/shareholders/search_company/'+search_term;

       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){

     				     this.m_coy.person = response.data.shareholder_company.person;
      					 this.m_coy.company_info = response.data.shareholder_company;

      					 this.m_coy_found = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Company not found. Please add this company to the "People" database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })
    	},
    	
    	searchCompany(type){
    	 
    	 	let uri = this.$base_url+'/api/v1/shareholders/search_company/'+ this.search_generic_company_id_num;
			
			swal.showLoading();
       		const vm = this;
      		ApiService.post(uri).then(response => {
      				swal.close();
      				if(response.data.exist == 1){
						
						 if(!response.data.shareholder_company.person){
						 	swal({
							  title: 'Error!',
							  text: 'Please add an authorized representative for this company in the "People" database first before generating the document.',
							  type: 'error',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							})
						 
						 
						 }
						 else{
							 this.sh_coy.person = response.data.shareholder_company.person;
							 this.sh_coy.company_info = response.data.shareholder_company;

							 this.sh_coy_found = true;
							 this.generic_company_found = true;
      					 }
      					 
      					 
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Company not found. Please add this company to the "People" database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })
    	 
    	},
        searchPerson(type){
       		let search_term = "NONE";
       		if(type == "officer"){
       			if(this.search_officer_id_num){
       				search_term = this.search_officer_id_num
       			}
       		}
       		else if(type == "shareholder"){
       			if(this.search_shareholder_id_num){
       				search_term = this.search_shareholder_id_num
       			}
       		}
       		else if(type == "member"){
       			if(this.search_member_id_num){
       				search_term = this.search_member_id_num
       			}
       		}
       		else if(type == "generic_person"){
       			if(this.search_generic_person_id_num){
       				search_term = this.search_generic_person_id_num
       			}
       		}
       		else if(type == "signer"){
       			if(this.search_signer_id_num){
       				search_term = this.search_signer_id_num
       			}
       		}

       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;

       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){


      					if(type == "officer"){

      						//if(!this.officer1.pid){
      							this.officer1.person = response.data.person;
      							this.officer1.pid = response.data.person.id;

      							this.officer1_found = true;
      						//}
      						/*else if(!this.officer2.pid){
      							this.officer2.person = response.data.person;
      							this.officer2.pid = response.data.person.id;

      							this.officer2_found = true;
      						}*/
      					}//end if search officers
      					
      					else if(type == "member"){
      						this.member1.person = response.data.person;
      						this.member1.pid = response.data.person.id;

      						this.member1_found = true;
      					
      					}//end if search members
						else if(type == "generic_person"){
						
							this.generic_person1.person = response.data.person;
      						this.generic_person1.pid = response.data.person.id;

      						this.generic_person1_found = true;
      						this.reso_options.generic_person1_gov_id = response.data.person.id;
						
						}
      					else if(type == "shareholder"){
      						//if(!this.sh1.pid){
      							this.sh1.person = response.data.person;
      							this.sh1.pid = response.data.person.id;

      							this.sh1_found = true;
      						//}
      						/*else if(!this.sh2.pid){
      							this.sh2.person = response.data.person;
      							this.sh2.pid = response.data.person.id;

      							this.sh2_found = true;
      						}*/

      					}
      					else if(type == "signer"){

      						this.additionalSigners.push(response.data.person);

      					}//end if-else
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'Person not found. Please add this person to the database first.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){


						})


      				}

     		 })

    	},//end search person
	   includeReso(r){
	   		if(r == "ch_coy_address"){
	   			this.resolutions.ch_coy_address = true;
	   		}
	   		else if(r == "ch_coy_name"){
	   			this.resolutions.ch_coy_name = true;
	   		}
	   		else if(r == "ch_coy_fye"){
	   			this.resolutions.ch_coy_fye = true;
	   		}
	   		else if(r == "ch_coy_activity"){
	   			this.resolutions.ch_coy_activity = true;
	   		}
	   		else if(r == "ch_officer"){
	   			this.displayOfficerSearch = true;
	   		}
	   		else if(r == "mc"){
	   			this.displayMemberSearch = true;
	   		
	   		}
	   		else if(r == "st"){
	   			this.displayShareholderSearch = true;
	   			this.sh1.transaction_type = 1;
    			this.sh_coy.transaction_type = 1;
	   		}
	   		else if(r == "create_sc" ){
	   			swal.showLoading();
	   			let uri = this.$base_url+'/api/v1/shareholders/full_entity/'+ this.$route.params.eid;
			 	ApiService.get(uri).then(response => {
						this.shareholders_list_full = response.data.shareholders;
						let vm = this;
						this.displayShareholderSelect = true;
						swal.close();
				})

	   		}
	   		else if(r == "cancel_sc"){
	   			swal.showLoading();
	   			let uri = this.$base_url+'/api/v1/shareholders/share_certs/entity/'+ this.$route.params.eid;
			 	ApiService.get(uri).then(response => {
						this.share_certs_list_full = response.data.share_certs;
						let vm = this;
						this.displayCancelShareCertSelect = true;
						swal.close();
				})

	   		}
	   		else if(r == "issue_sc"){
	   			swal.showLoading();
	   			let uri = this.$base_url+'/api/v1/shareholders/share_certs/entity/'+ this.$route.params.eid;
			 	ApiService.get(uri).then(response => {
						this.share_certs_list_full = response.data.share_certs;
						let vm = this;
						this.displayIssueShareCertSelect = true;
						swal.close();
				})

	   		}
	   },
	   excludeReso(r){
	   		if(r == "ch_coy_address"){
	   			this.resolutions.ch_coy_address = false;
	   		}
	   		else if(r == "ch_coy_name"){
	   			this.resolutions.ch_coy_name = false;
	   		}
	   		else if(r == "ch_coy_fye"){
	   			this.resolutions.ch_coy_fye = false;
	   		}
	   		else if(r == "ch_coy_activity"){
	   			this.resolutions.ch_coy_activity= false;
	   		}
	   },
       goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	    },
    },


  }
</script>
<style>
.field_error_cs{
	border:2px solid red!important;
}

.ecTaskActive{
	color:green;
	font-weight:bold;
}

</style>
